import { SimulationConfig, MelodyInstrument, VisualPreset, AudioPreset } from './types';

export const VISUAL_PRESETS: VisualPreset[] = [
    {
        name: "No Preset",
        category: "Basic",
        settings: {
            ballStyle: 'NONE',
            ballTexture: 'NONE',
            ballFillType: 'SOLID',
            ballFillOpacity: 1.0,
            ballStrokeWidth: 0,
            ballGlowRadius: 0,
            rgbLighting: false,
            useBallRGB: false,
            ballPlacementIndividualEnabled: false
        }
    },
    {
        name: "Neon Nights",
        category: "Vibrant",
        settings: {
            ballStyle: 'NEON',
            ballFillType: 'SOLID',
            ballFillOpacity: 0.9,
            ballStrokeWidth: 3,
            ballStrokeOpacity: 1.0,
            ballGlowRadius: 15,
            ballGlowOpacity: 0.8,
            rgbLighting: true,
            useBallRGB: true,
            hueCycleSpeed: 2
        }
    },
    {
        name: "Chrome Sphere",
        category: "Metallic",
        settings: {
            ballStyle: 'CHROME',
            ballFillType: 'SOLID',
            ballFillOpacity: 1.0,
            ballStrokeWidth: 1,
            ballStrokeOpacity: 0.5,
            ballGlowRadius: 5,
            ballGlowOpacity: 0.3,
            rgbLighting: false,
            ball1Color: '#ffffff'
        }
    },
    {
        name: "Ghostly Trail",
        category: "Minimal",
        settings: {
            ballStyle: 'GHOST',
            ballFillType: 'HOLLOW',
            ballFillOpacity: 0.2,
            ballStrokeWidth: 2,
            ballStrokeOpacity: 0.8,
            trailLength: 50,
            trailOpacity: 0.5,
            trailStartScale: 1.0,
            trailEndScale: 0.1
        }
    },
    {
        name: "Crystal Clear",
        category: "Glass",
        settings: {
            ballStyle: 'CRYSTAL',
            ballFillType: 'SOLID',
            ballFillOpacity: 0.4,
            ballStrokeWidth: 1,
            ballStrokeOpacity: 0.6,
            ballGlowRadius: 10,
            ballGlowOpacity: 0.5,
            ball1Color: '#aaddff'
        }
    },
    {
        name: "Plasma Pulse",
        category: "Vibrant",
        settings: {
            ballStyle: 'PLASMA',
            ballFillType: 'GRADIENT_RADIAL',
            ballFillOpacity: 1.0,
            ballPulseSpeed: 2.0,
            rgbLighting: true,
            useBallRGB: true,
            hueCycleSpeed: 5
        }
    },
    {
        name: "Retro Grid",
        category: "Retro",
        settings: {
            ballStyle: 'WIREFRAME',
            ballTexture: 'CHECKERBOARD',
            ballTextureOpacity: 0.5,
            ballStrokeWidth: 2,
            ballStrokeOpacity: 1.0,
            ball1Color: '#00ff00'
        }
    },
    {
        name: "Frosted Glass",
        category: "Glass",
        settings: {
            ballStyle: 'FROSTED',
            ballFillType: 'SOLID',
            ballFillOpacity: 0.7,
            ball1Color: '#ffffff',
            ballGlowRadius: 20,
            ballGlowOpacity: 0.3
        }
    },
    {
        name: "Honey Comb",
        category: "Pattern",
        settings: {
            ballStyle: 'MATTE',
            ballTexture: 'HONEYCOMB',
            ballTextureOpacity: 0.8,
            ball1Color: '#ffcc00'
        }
    },
    {
        name: "Golden Treasure",
        category: "Metallic",
        settings: {
            ballStyle: 'GOLD',
            ballFillType: 'SOLID',
            ballFillOpacity: 1.0,
            ballStrokeWidth: 2,
            ballStrokeColor: '#ffd700',
            ballGlowRadius: 10,
            ballGlowOpacity: 0.5,
            ball1Color: '#ffd700'
        }
    },
    {
        name: "Emerald Forest",
        category: "Nature",
        settings: {
            ballStyle: 'EMERALD',
            ballTexture: 'LEAF',
            ballTextureOpacity: 0.6,
            ball1Color: '#50c878',
            ballGlowRadius: 15,
            ballGlowColor: '#50c878'
        }
    },
    {
        name: "Lava Flow",
        category: "Vibrant",
        settings: {
            ballStyle: 'LAVA',
            ballTexture: 'FIRE',
            ballTextureOpacity: 0.7,
            ball1Color: '#ff4500',
            ballGlowRadius: 20,
            ballGlowColor: '#ff4500'
        }
    },
    {
        name: "Electric Storm",
        category: "Tech",
        settings: {
            ballStyle: 'ELECTRIC',
            ballTexture: 'MATRIX',
            ballTextureOpacity: 0.5,
            ball1Color: '#00ffff',
            ballGlowRadius: 25,
            ballGlowColor: '#00ffff'
        }
    },
    {
        name: "Carbon Fiber",
        category: "Tech",
        settings: {
            ballStyle: 'CARBON',
            ballTexture: 'CROSSHATCH',
            ballTextureOpacity: 0.8,
            ball1Color: '#333333',
            ballStrokeWidth: 1,
            ballStrokeColor: '#666666'
        }
    },
    {
        name: "Marble Statue",
        category: "Stone",
        settings: {
            ballStyle: 'MARBLE',
            ballFillType: 'SOLID',
            ball1Color: '#ffffff',
            ballStrokeWidth: 1,
            ballStrokeColor: '#cccccc'
        }
    },
    {
        name: "Galaxy Sphere",
        category: "Space",
        settings: {
            ballStyle: 'SHINY',
            ballTexture: 'GALAXY',
            ballTextureOpacity: 0.9,
            ball1Color: '#000033',
            ballGlowRadius: 30,
            ballGlowColor: '#4444ff'
        }
    },
    {
        name: "Ruby Gem",
        category: "Gem",
        settings: {
            ballStyle: 'RUBY',
            ballFillType: 'SOLID',
            ball1Color: '#ff0000',
            ballGlowRadius: 15,
            ballGlowColor: '#ff0000'
        }
    },
    {
        name: "Sapphire Depths",
        category: "Gem",
        settings: {
            ballStyle: 'SAPPHIRE',
            ballFillType: 'SOLID',
            ball1Color: '#0f52ba',
            ballGlowRadius: 15,
            ballGlowColor: '#0f52ba'
        }
    }
];

export const PRESET_LIBRARY: AudioPreset[] = [
    // ATMOSPHERIC & AMBIENT
    { 
        name: "Ethereal Dream", 
        category: "Atmospheric", 
        instrument: "ETHEREAL_CHIME",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["dreamy", "space", "soft"],
        settings: { audioEcho: true, audioReverbLevel: 0.8, audioDistortionLevel: 0, audioDelayTime: 0.5, audioDelayFeedback: 0.6, melodyInstrument: 'ETHEREAL_CHIME', audioLowPassFreq: 3000, audioEchoStereoWidth: 0.8 } 
    },
    { 
        name: "Cathedral", 
        category: "Atmospheric", 
        instrument: "STRING_ENSEMBLE_1",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["huge", "reverb", "solemn"],
        settings: { audioEcho: true, audioReverbLevel: 0.95, audioDelayTime: 0.8, audioDelayFeedback: 0.2, melodyInstrument: 'STRING_ENSEMBLE_1', audioLowPassFreq: 5000 } 
    },
    { 
        name: "Space Station", 
        category: "Atmospheric", 
        instrument: "PURE_SINE",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["sci-fi", "clean", "minimal"],
        settings: { audioEcho: true, audioDelayTime: 0.6, audioDelayFeedback: 0.8, audioReverbLevel: 0.2, melodyInstrument: 'PURE_SINE', audioHighPassFreq: 200 } 
    },
    { 
        name: "Cave Echo", 
        category: "Atmospheric", 
        instrument: "PAN_FLUTE",
        echoType: "MONO",
        clarity: "AMBIENT",
        tags: ["nature", "echo", "dark"],
        settings: { audioEcho: true, audioDelayTime: 0.4, audioDelayFeedback: 0.5, audioReverbLevel: 0.5, melodyInstrument: 'PAN_FLUTE', audioLowPassFreq: 1500 } 
    },
    { 
        name: "Deep Ocean", 
        category: "Atmospheric", 
        instrument: "WARM_PAD",
        echoType: "NONE",
        clarity: "MUFFLED",
        tags: ["underwater", "deep", "calm"],
        settings: { audioEcho: false, audioReverbLevel: 0.9, audioLowPassFreq: 400, melodyInstrument: 'WARM_PAD', audioLowPassResonance: 5.0 } 
    },
    { 
        name: "Midnight Mist", 
        category: "Atmospheric", 
        instrument: "HALO_PAD",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["night", "mysterious", "soft"],
        settings: { audioEcho: true, audioReverbLevel: 0.7, audioDelayTime: 1.2, audioDelayFeedback: 0.4, melodyInstrument: 'HALO_PAD' } 
    },
    { 
        name: "Cloud Surfing", 
        category: "Atmospheric", 
        instrument: "NEW_AGE_PAD",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["airy", "light", "peaceful"],
        settings: { audioEcho: true, audioReverbLevel: 0.6, audioDelayTime: 0.4, audioDelayFeedback: 0.3, melodyInstrument: 'NEW_AGE_PAD', audioHighPassFreq: 500 } 
    },
    { 
        name: "Arctic Wind", 
        category: "Atmospheric", 
        instrument: "WHISTLE",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["cold", "wind", "sharp"],
        settings: { audioEcho: true, audioReverbLevel: 0.8, audioLowPassFreq: 2000, melodyInstrument: 'WHISTLE', audioDelayTime: 0.1, audioDelayFeedback: 0.7 } 
    },
    { 
        name: "Zen Garden", 
        category: "Atmospheric", 
        instrument: "KOTO",
        echoType: "SHORT",
        clarity: "CLEAR",
        tags: ["meditation", "peace", "oriental"],
        settings: { audioEcho: true, audioReverbLevel: 0.4, audioDelayTime: 0.6, audioDelayFeedback: 0.2, melodyInstrument: 'KOTO' } 
    },
    { 
        name: "Stellar Void", 
        category: "Atmospheric", 
        instrument: "SCI_FI_FX",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["space", "empty", "vast"],
        settings: { audioEcho: true, audioReverbLevel: 1.0, audioDelayTime: 1.5, audioDelayFeedback: 0.5, melodyInstrument: 'SCI_FI_FX' } 
    },
    { 
        name: "Nebula", 
        category: "Atmospheric", 
        instrument: "ATMOSPHERE_FX",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["cosmic", "colorful", "soft"],
        settings: { audioEcho: true, audioReverbLevel: 0.8, audioDelayTime: 0.9, audioDelayFeedback: 0.4, melodyInstrument: 'ATMOSPHERE_FX' } 
    },
    { 
        name: "Ghostly Whispers", 
        category: "Atmospheric", 
        instrument: "VOICE_OOHS",
        echoType: "STEREO",
        clarity: "DISTORTED",
        tags: ["scary", "vocal", "haunted"],
        settings: { audioEcho: true, audioReverbLevel: 0.9, audioDistortionLevel: 10, melodyInstrument: 'VOICE_OOHS', audioPitchShift: -2 } 
    },
    { 
        name: "Crystal Forest", 
        category: "Atmospheric", 
        instrument: "CRYSTAL_FX",
        echoType: "SHORT",
        clarity: "CLEAR",
        tags: ["bright", "magical", "nature"],
        settings: { audioEcho: true, audioReverbLevel: 0.5, audioDelayTime: 0.3, audioDelayFeedback: 0.4, melodyInstrument: 'CRYSTAL_FX' } 
    },
    { 
        name: "Aura", 
        category: "Atmospheric", 
        instrument: "BRIGHTNESS_FX",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["light", "energy", "glow"],
        settings: { audioEcho: true, audioReverbLevel: 0.7, audioDelayTime: 0.5, audioDelayFeedback: 0.5, melodyInstrument: 'BRIGHTNESS_FX' } 
    },
    { 
        name: "Distant Memory", 
        category: "Atmospheric", 
        instrument: "MUSIC_BOX",
        echoType: "LONG",
        clarity: "MUFFLED",
        tags: ["nostalgia", "soft", "old"],
        settings: { audioEcho: true, audioReverbLevel: 0.6, audioLowPassFreq: 1200, melodyInstrument: 'MUSIC_BOX', audioDelayTime: 0.7, audioDelayFeedback: 0.3 } 
    },

    // RETRO & 8-BIT
    { 
        name: "8-Bit Arcade", 
        category: "Retro", 
        instrument: "8BIT_LEAD",
        echoType: "NONE",
        clarity: "DISTORTED",
        tags: ["arcade", "classic", "crunchy"],
        settings: { audioEcho: false, audioReverbLevel: 0, audioDistortionLevel: 25, melodyInstrument: '8BIT_LEAD', audioLowPassFreq: 12000 } 
    },
    { 
        name: "Retro Synth", 
        category: "Retro", 
        instrument: "8BIT_LEAD",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["80s", "synth", "cool"],
        settings: { audioEcho: true, audioDistortionLevel: 5, audioReverbLevel: 0.3, melodyInstrument: '8BIT_LEAD', audioDelayTime: 0.2, audioDelayFeedback: 0.4 } 
    },
    { 
        name: "Game Boy Color", 
        category: "Retro", 
        instrument: "SQUARE_LEAD",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["handheld", "nintendo", "simple"],
        settings: { audioEcho: false, audioDistortionLevel: 10, melodyInstrument: 'SQUARE_LEAD', audioHighPassFreq: 100 } 
    },
    { 
        name: "NES Adventure", 
        category: "Retro", 
        instrument: "SAWTOOTH_LEAD",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["heroic", "8-bit", "classic"],
        settings: { audioEcho: false, audioDistortionLevel: 15, melodyInstrument: 'SAWTOOTH_LEAD', audioHighPassFreq: 200 } 
    },
    { 
        name: "Commodore 64", 
        category: "Retro", 
        instrument: "8BIT_LEAD",
        echoType: "MONO",
        clarity: "DISTORTED",
        tags: ["sid", "vintage", "computer"],
        settings: { audioEcho: true, audioDelayTime: 0.1, audioDelayFeedback: 0.4, melodyInstrument: '8BIT_LEAD', audioDistortionLevel: 20 } 
    },
    { 
        name: "Pixel Hero", 
        category: "Retro", 
        instrument: "BASS_LEAD",
        echoType: "NONE",
        clarity: "DISTORTED",
        tags: ["power", "low", "pixel"],
        settings: { audioEcho: false, audioDistortionLevel: 30, melodyInstrument: 'BASS_LEAD', audioPitchShift: -12 } 
    },
    { 
        name: "Synthwave Night", 
        category: "Retro", 
        instrument: "POLYSYNTH_PAD",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["neon", "80s", "drive"],
        settings: { audioEcho: true, audioReverbLevel: 0.4, audioDelayTime: 0.3, audioDelayFeedback: 0.5, melodyInstrument: 'POLYSYNTH_PAD' } 
    },
    { 
        name: "Vaporwave", 
        category: "Retro", 
        instrument: "ELECTRIC_PIANO",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["aesthetic", "slow", "chill"],
        settings: { audioEcho: true, audioReverbLevel: 0.6, audioPitchShift: -2, melodyInstrument: 'ELECTRIC_PIANO', audioDelayTime: 0.8, audioDelayFeedback: 0.6 } 
    },
    { 
        name: "Arcade Cabinet", 
        category: "Retro", 
        instrument: "CALLIOPE_LEAD",
        echoType: "NONE",
        clarity: "DISTORTED",
        tags: ["loud", "arcade", "fun"],
        settings: { audioEcho: false, audioDistortionLevel: 40, melodyInstrument: 'CALLIOPE_LEAD' } 
    },
    { 
        name: "Bit-Crushed", 
        category: "Retro", 
        instrument: "8BIT_LEAD",
        echoType: "NONE",
        clarity: "DISTORTED",
        tags: ["glitch", "broken", "digital"],
        settings: { audioEcho: false, audioDistortionLevel: 80, audioLowPassFreq: 4000, melodyInstrument: '8BIT_LEAD', audioBitcrushDepth: 4 } 
    },
    { 
        name: "Chip Tune", 
        category: "Retro", 
        instrument: "SQUARE_LEAD",
        echoType: "SHORT",
        clarity: "CLEAR",
        tags: ["bouncy", "fast", "game"],
        settings: { audioEcho: true, audioDelayTime: 0.15, audioDelayFeedback: 0.6, melodyInstrument: 'SQUARE_LEAD' } 
    },
    { 
        name: "Dungeon Crawler", 
        category: "Retro", 
        instrument: "8BIT_LEAD",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["dark", "rpg", "mystery"],
        settings: { audioEcho: true, audioReverbLevel: 0.5, audioPitchShift: -5, melodyInstrument: '8BIT_LEAD', audioDelayTime: 0.6, audioDelayFeedback: 0.4 } 
    },
    { 
        name: "Level Up", 
        category: "Retro", 
        instrument: "GLOCKENSPIEL",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["reward", "bright", "short"],
        settings: { audioEcho: false, audioReverbLevel: 0.2, melodyInstrument: 'GLOCKENSPIEL', audioPitchShift: 12 } 
    },
    { 
        name: "Boss Fight", 
        category: "Retro", 
        instrument: "SAWTOOTH_LEAD",
        echoType: "STEREO",
        clarity: "DISTORTED",
        tags: ["intense", "fast", "battle"],
        settings: { audioEcho: true, audioDistortionLevel: 20, audioDelayTime: 0.2, audioDelayFeedback: 0.5, melodyInstrument: 'SAWTOOTH_LEAD' } 
    },
    { 
        name: "Game Over", 
        category: "Retro", 
        instrument: "8BIT_LEAD",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["sad", "fail", "slow"],
        settings: { audioEcho: true, audioReverbLevel: 0.4, audioPitchShift: -12, melodyInstrument: '8BIT_LEAD', audioDelayTime: 1.0, audioDelayFeedback: 0.7 } 
    },

    // ORCHESTRAL & EPIC
    { 
        name: "Orchestral Hall", 
        category: "Orchestral", 
        instrument: "STRING_ENSEMBLE_1",
        echoType: "NONE",
        clarity: "AMBIENT",
        tags: ["classic", "grand", "strings"],
        settings: { audioEcho: false, audioReverbLevel: 0.7, melodyInstrument: 'STRING_ENSEMBLE_1' } 
    },
    { 
        name: "Cinematic Epic", 
        category: "Orchestral", 
        instrument: "BRASS_SECTION",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["movie", "heroic", "brass"],
        settings: { audioEcho: true, audioReverbLevel: 0.8, audioDelayTime: 0.4, audioDelayFeedback: 0.3, melodyInstrument: 'BRASS_SECTION' } 
    },
    { 
        name: "Royal Palace", 
        category: "Orchestral", 
        instrument: "TRUMPET",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["noble", "bright", "fanfare"],
        settings: { audioEcho: true, audioReverbLevel: 0.5, melodyInstrument: 'TRUMPET', audioDelayTime: 0.3, audioDelayFeedback: 0.2 } 
    },
    { 
        name: "Dark Knight", 
        category: "Orchestral", 
        instrument: "CELLO",
        echoType: "MONO",
        clarity: "AMBIENT",
        tags: ["batman", "moody", "low"],
        settings: { audioEcho: true, audioReverbLevel: 0.6, audioPitchShift: -7, melodyInstrument: 'CELLO', audioDelayTime: 0.5, audioDelayFeedback: 0.4 } 
    },
    { 
        name: "Angelic Choir", 
        category: "Orchestral", 
        instrument: "CHOIR_AAHS",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["heavenly", "vocal", "soft"],
        settings: { audioEcho: true, audioReverbLevel: 0.9, melodyInstrument: 'CHOIR_AAHS', audioDelayTime: 1.0, audioDelayFeedback: 0.5 } 
    },
    { 
        name: "Viking Raid", 
        category: "Orchestral", 
        instrument: "FRENCH_HORN",
        echoType: "NONE",
        clarity: "DISTORTED",
        tags: ["war", "ancient", "brass"],
        settings: { audioEcho: false, audioDistortionLevel: 10, melodyInstrument: 'FRENCH_HORN', audioPitchShift: -2 } 
    },
    { 
        name: "Imperial March", 
        category: "Orchestral", 
        instrument: "TROMBONE",
        echoType: "SHORT",
        clarity: "CLEAR",
        tags: ["star wars", "evil", "brass"],
        settings: { audioEcho: true, audioDelayTime: 0.2, audioDelayFeedback: 0.3, melodyInstrument: 'TROMBONE', audioPitchShift: -5 } 
    },
    { 
        name: "Harp Sanctuary", 
        category: "Orchestral", 
        instrument: "ORCHESTRAL_HARP",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["peaceful", "pluck", "soft"],
        settings: { audioEcho: true, audioReverbLevel: 0.4, melodyInstrument: 'ORCHESTRAL_HARP', audioDelayTime: 0.4, audioDelayFeedback: 0.4 } 
    },
    { 
        name: "Timpani Thunder", 
        category: "Orchestral", 
        instrument: "TIMPANI",
        echoType: "NONE",
        clarity: "AMBIENT",
        tags: ["drums", "impact", "low"],
        settings: { audioEcho: false, audioReverbLevel: 0.3, audioPitchShift: -12, melodyInstrument: 'TIMPANI' } 
    },
    { 
        name: "Staccato Strings", 
        category: "Orchestral", 
        instrument: "PIZZICATO_STRINGS",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["fast", "pluck", "strings"],
        settings: { audioEcho: false, audioReverbLevel: 0.2, melodyInstrument: 'PIZZICATO_STRINGS' } 
    },
    { 
        name: "Violin Solo", 
        category: "Orchestral", 
        instrument: "VIOLIN",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["emotional", "strings", "high"],
        settings: { audioEcho: true, audioReverbLevel: 0.5, melodyInstrument: 'VIOLIN', audioDelayTime: 0.3, audioDelayFeedback: 0.3 } 
    },
    { 
        name: "Cello Weep", 
        category: "Orchestral", 
        instrument: "CELLO",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["sad", "strings", "low"],
        settings: { audioEcho: true, audioReverbLevel: 0.6, melodyInstrument: 'CELLO', audioDelayTime: 0.4, audioDelayFeedback: 0.4 } 
    },
    { 
        name: "Brass Fanfare", 
        category: "Orchestral", 
        instrument: "BRASS_SECTION",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["celebration", "bright", "brass"],
        settings: { audioEcho: true, audioReverbLevel: 0.4, melodyInstrument: 'BRASS_SECTION', audioDelayTime: 0.2, audioDelayFeedback: 0.3 } 
    },
    { 
        name: "Gothic Organ", 
        category: "Orchestral", 
        instrument: "CHURCH_ORGAN",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["dark", "church", "powerful"],
        settings: { audioEcho: true, audioReverbLevel: 0.8, melodyInstrument: 'CHURCH_ORGAN', audioDelayTime: 0.6, audioDelayFeedback: 0.5 } 
    },
    { 
        name: "Orchestra Hit", 
        category: "Orchestral", 
        instrument: "ORCHESTRA_HIT",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["impact", "classic", "short"],
        settings: { audioEcho: false, audioReverbLevel: 0.3, melodyInstrument: 'ORCHESTRA_HIT' } 
    },

    // ELECTRONIC & SYNTH
    { 
        name: "Cyberpunk City", 
        category: "Electronic", 
        instrument: "SYNTH_PLUCK",
        echoType: "STEREO",
        clarity: "DISTORTED",
        tags: ["neon", "future", "tech"],
        settings: { audioEcho: true, audioReverbLevel: 0.6, audioDistortionLevel: 10, audioDelayTime: 0.3, audioDelayFeedback: 0.5, melodyInstrument: 'SYNTH_PLUCK' } 
    },
    { 
        name: "Neon Lights", 
        category: "Electronic", 
        instrument: "SAWTOOTH_LEAD",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["bright", "80s", "synth"],
        settings: { audioEcho: true, audioDelayTime: 0.2, audioDelayFeedback: 0.5, melodyInstrument: 'SAWTOOTH_LEAD', audioReverbLevel: 0.3 } 
    },
    { 
        name: "Deep Bass", 
        category: "Electronic", 
        instrument: "SYNTH_BASS_1",
        echoType: "NONE",
        clarity: "MUFFLED",
        tags: ["low", "sub", "club"],
        settings: { audioEcho: false, audioLowPassFreq: 300, audioDistortionLevel: 10, melodyInstrument: 'SYNTH_BASS_1', audioPitchShift: -12 } 
    },
    { 
        name: "Acid House", 
        category: "Electronic", 
        instrument: "SAWTOOTH_LEAD",
        echoType: "MONO",
        clarity: "DISTORTED",
        tags: ["303", "squelch", "rave"],
        settings: { audioEcho: true, audioLowPassFreq: 2000, audioLowPassResonance: 15.0, melodyInstrument: 'SAWTOOTH_LEAD', audioDelayTime: 0.1, audioDelayFeedback: 0.6 } 
    },
    { 
        name: "Techno Pulse", 
        category: "Electronic", 
        instrument: "SQUARE_LEAD",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["beat", "club", "fast"],
        settings: { audioEcho: false, audioDistortionLevel: 5, melodyInstrument: 'SQUARE_LEAD', audioPitchShift: -5 } 
    },
    { 
        name: "Trance Energy", 
        category: "Electronic", 
        instrument: "SYNTH_STRINGS_1",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["uplifting", "fast", "rave"],
        settings: { audioEcho: true, audioDelayTime: 0.375, audioDelayFeedback: 0.6, melodyInstrument: 'SYNTH_STRINGS_1', audioReverbLevel: 0.5 } 
    },
    { 
        name: "Dubstep Growl", 
        category: "Electronic", 
        instrument: "SYNTH_BASS_2",
        echoType: "NONE",
        clarity: "DISTORTED",
        tags: ["wobble", "heavy", "bass"],
        settings: { audioEcho: false, audioDistortionLevel: 50, audioLowPassFreq: 1000, audioLowPassResonance: 10.0, melodyInstrument: 'SYNTH_BASS_2', audioPitchShift: -12 } 
    },
    { 
        name: "Future Bass", 
        category: "Electronic", 
        instrument: "SYNTH_PLUCK",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["modern", "bright", "pop"],
        settings: { audioEcho: true, audioReverbLevel: 0.4, audioDelayTime: 0.2, audioDelayFeedback: 0.4, melodyInstrument: 'SYNTH_PLUCK' } 
    },
    { 
        name: "Ambient Techno", 
        category: "Electronic", 
        instrument: "WARM_PAD",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["chill", "deep", "loop"],
        settings: { audioEcho: true, audioReverbLevel: 0.7, audioDelayTime: 0.8, audioDelayFeedback: 0.6, melodyInstrument: 'WARM_PAD' } 
    },
    { 
        name: "Digital Rain", 
        category: "Electronic", 
        instrument: "RAIN_FX",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["glitch", "water", "digital"],
        settings: { audioEcho: true, audioDelayTime: 0.1, audioDelayFeedback: 0.8, melodyInstrument: 'RAIN_FX', audioHighPassFreq: 1000 } 
    },
    { 
        name: "Warp Drive", 
        category: "Electronic", 
        instrument: "SWEEP_PAD",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["space", "movement", "sci-fi"],
        settings: { audioEcho: true, audioDelayTime: 0.05, audioDelayFeedback: 0.9, melodyInstrument: 'SWEEP_PAD' } 
    },
    { 
        name: "Robotic Voice", 
        category: "Electronic", 
        instrument: "SYNTH_VOICE",
        echoType: "STEREO",
        clarity: "DISTORTED",
        tags: ["robot", "vocal", "tech"],
        settings: { audioEcho: true, audioDistortionLevel: 20, melodyInstrument: 'SYNTH_VOICE', audioDelayTime: 0.3, audioDelayFeedback: 0.4 } 
    },
    { 
        name: "Laser Grid", 
        category: "Electronic", 
        instrument: "SAWTOOTH_LEAD",
        echoType: "SHORT",
        clarity: "CLEAR",
        tags: ["sharp", "light", "future"],
        settings: { audioEcho: true, audioDelayTime: 0.1, audioDelayFeedback: 0.3, melodyInstrument: 'SAWTOOTH_LEAD', audioHighPassFreq: 500 } 
    },
    { 
        name: "Circuit Bend", 
        category: "Electronic", 
        instrument: "8BIT_LEAD",
        echoType: "MONO",
        clarity: "DISTORTED",
        tags: ["glitch", "broken", "noise"],
        settings: { audioEcho: true, audioDistortionLevel: 60, audioPitchShift: 5, melodyInstrument: '8BIT_LEAD', audioDelayTime: 0.05, audioDelayFeedback: 0.8 } 
    },
    { 
        name: "Plasma Coil", 
        category: "Electronic", 
        instrument: "SYNTH_BRASS_1",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["energy", "bright", "electric"],
        settings: { audioEcho: true, audioReverbLevel: 0.3, melodyInstrument: 'SYNTH_BRASS_1', audioDelayTime: 0.2, audioDelayFeedback: 0.4 } 
    },

    // PERCUSSIVE & SHARP
    { 
        name: "Wooden Toy", 
        category: "Percussive", 
        instrument: "MARIMBA",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["nature", "short", "wood"],
        settings: { audioEcho: false, audioReverbLevel: 0.05, audioLowPassFreq: 8000, melodyInstrument: 'MARIMBA' } 
    },
    { 
        name: "Glassworks", 
        category: "Percussive", 
        instrument: "CELESTA",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["bright", "fragile", "bell"],
        settings: { audioEcho: true, audioReverbLevel: 0.3, audioLowPassFreq: 15000, audioLowPassResonance: 5.0, melodyInstrument: 'CELESTA', audioDelayTime: 0.4, audioDelayFeedback: 0.3 } 
    },
    { 
        name: "Steel Drums", 
        category: "Percussive", 
        instrument: "STEEL_DRUMS",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["island", "metal", "happy"],
        settings: { audioEcho: true, audioReverbLevel: 0.2, melodyInstrument: 'STEEL_DRUMS', audioDelayTime: 0.3, audioDelayFeedback: 0.4 } 
    },
    { 
        name: "Xylophone Fun", 
        category: "Percussive", 
        instrument: "XYLOPHONE",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["bright", "fast", "wood"],
        settings: { audioEcho: false, audioReverbLevel: 0.1, melodyInstrument: 'XYLOPHONE' } 
    },
    { 
        name: "Music Box", 
        category: "Percussive", 
        instrument: "MUSIC_BOX",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["nostalgia", "soft", "bell"],
        settings: { audioEcho: true, audioReverbLevel: 0.4, melodyInstrument: 'MUSIC_BOX', audioDelayTime: 0.5, audioDelayFeedback: 0.5 } 
    },
    { 
        name: "Bamboo Forest", 
        category: "Percussive", 
        instrument: "WOODBLOCK",
        echoType: "MONO",
        clarity: "CLEAR",
        tags: ["nature", "percussion", "wood"],
        settings: { audioEcho: true, audioDelayTime: 0.2, audioDelayFeedback: 0.4, melodyInstrument: 'WOODBLOCK' } 
    },
    { 
        name: "Clockwork", 
        category: "Percussive", 
        instrument: "TINKLE_BELL",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["mechanical", "short", "metal"],
        settings: { audioEcho: false, audioReverbLevel: 0, melodyInstrument: 'TINKLE_BELL' } 
    },
    { 
        name: "Kalimba Peace", 
        category: "Percussive", 
        instrument: "KALIMBA",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["thumb piano", "soft", "nature"],
        settings: { audioEcho: true, audioReverbLevel: 0.3, melodyInstrument: 'KALIMBA', audioDelayTime: 0.4, audioDelayFeedback: 0.4 } 
    },
    { 
        name: "Agogo Bells", 
        category: "Percussive", 
        instrument: "AGOGO",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["latin", "metal", "bright"],
        settings: { audioEcho: true, audioDelayTime: 0.1, audioDelayFeedback: 0.5, melodyInstrument: 'AGOGO' } 
    },
    { 
        name: "Taiko Spirit", 
        category: "Percussive", 
        instrument: "TAIKO_DRUM",
        echoType: "NONE",
        clarity: "AMBIENT",
        tags: ["drums", "power", "japan"],
        settings: { audioEcho: false, audioReverbLevel: 0.4, audioPitchShift: -12, melodyInstrument: 'TAIKO_DRUM' } 
    },
    { 
        name: "Glockenspiel High", 
        category: "Percussive", 
        instrument: "GLOCKENSPIEL",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["bright", "metal", "high"],
        settings: { audioEcho: true, audioReverbLevel: 0.2, melodyInstrument: 'GLOCKENSPIEL', audioDelayTime: 0.3, audioDelayFeedback: 0.3 } 
    },
    { 
        name: "Tubular Bells", 
        category: "Percussive", 
        instrument: "TUBULAR_BELLS",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["church", "metal", "grand"],
        settings: { audioEcho: true, audioReverbLevel: 0.6, melodyInstrument: 'TUBULAR_BELLS', audioDelayTime: 0.8, audioDelayFeedback: 0.4 } 
    },
    { 
        name: "Vibraphone Jazz", 
        category: "Percussive", 
        instrument: "VIBRAPHONE",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["jazz", "mellow", "metal"],
        settings: { audioEcho: true, audioReverbLevel: 0.3, audioDelayTime: 0.4, audioDelayFeedback: 0.5, melodyInstrument: 'VIBRAPHONE' } 
    },
    { 
        name: "Dulcimer Pluck", 
        category: "Percussive", 
        instrument: "DULCIMER",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["folk", "strings", "pluck"],
        settings: { audioEcho: true, audioReverbLevel: 0.2, melodyInstrument: 'DULCIMER', audioDelayTime: 0.3, audioDelayFeedback: 0.3 } 
    },
    { 
        name: "Hammered Metal", 
        category: "Percussive", 
        instrument: "STEEL_DRUMS",
        echoType: "NONE",
        clarity: "DISTORTED",
        tags: ["industrial", "metal", "harsh"],
        settings: { audioEcho: false, audioDistortionLevel: 10, melodyInstrument: 'STEEL_DRUMS', audioPitchShift: -5 } 
    },

    // EXPERIMENTAL & GLITCH
    { 
        name: "Broken Radio", 
        category: "Experimental", 
        instrument: "SYNTH_PLUCK",
        echoType: "NONE",
        clarity: "DISTORTED",
        tags: ["lo-fi", "noise", "old"],
        settings: { audioEcho: false, audioDistortionLevel: 60, audioLowPassFreq: 2000, audioLowPassResonance: 1.0, melodyInstrument: 'SYNTH_PLUCK' } 
    },
    { 
        name: "Horror Movie", 
        category: "Experimental", 
        instrument: "STRING_ENSEMBLE_1",
        echoType: "LONG",
        clarity: "DISTORTED",
        tags: ["scary", "tension", "dark"],
        settings: { audioEcho: true, audioDistortionLevel: 30, audioDelayTime: 0.1, audioDelayFeedback: 0.9, melodyInstrument: 'STRING_ENSEMBLE_1', audioPitchShift: -5 } 
    },
    { 
        name: "Alien Signal", 
        category: "Experimental", 
        instrument: "PURE_SINE",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["sci-fi", "space", "weird"],
        settings: { audioEcho: true, audioDelayTime: 0.01, audioDelayFeedback: 0.95, melodyInstrument: 'PURE_SINE' } 
    },
    { 
        name: "Glitch Hop", 
        category: "Experimental", 
        instrument: "8BIT_LEAD",
        echoType: "STEREO",
        clarity: "DISTORTED",
        tags: ["beat", "glitch", "fast"],
        settings: { audioEcho: true, audioDelayTime: 0.05, audioDistortionLevel: 40, melodyInstrument: '8BIT_LEAD', audioDelayFeedback: 0.6 } 
    },
    { 
        name: "Time Warp", 
        category: "Experimental", 
        instrument: "ETHEREAL_CHIME",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["space", "slow", "dreamy"],
        settings: { audioEcho: true, audioDelayTime: 1.0, audioDelayFeedback: 0.8, audioPitchShift: 12, melodyInstrument: 'ETHEREAL_CHIME' } 
    },
    { 
        name: "Industrial Noise", 
        category: "Experimental", 
        instrument: "DISTORTION_GUITAR",
        echoType: "NONE",
        clarity: "DISTORTED",
        tags: ["harsh", "metal", "factory"],
        settings: { audioEcho: false, audioDistortionLevel: 100, audioLowPassFreq: 5000, melodyInstrument: 'DISTORTION_GUITAR' } 
    },
    { 
        name: "Cyber Void", 
        category: "Experimental", 
        instrument: "ECHOES_FX",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["empty", "dark", "future"],
        settings: { audioEcho: true, audioReverbLevel: 0.9, audioDistortionLevel: 20, melodyInstrument: 'ECHOES_FX', audioDelayTime: 1.2, audioDelayFeedback: 0.6 } 
    },
    { 
        name: "Data Stream", 
        category: "Experimental", 
        instrument: "8BIT_LEAD",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["fast", "digital", "tech"],
        settings: { audioEcho: true, audioDelayTime: 0.02, audioDelayFeedback: 0.7, melodyInstrument: '8BIT_LEAD' } 
    },
    { 
        name: "Radioactive", 
        category: "Experimental", 
        instrument: "SAWTOOTH_LEAD",
        echoType: "STEREO",
        clarity: "DISTORTED",
        tags: ["danger", "buzz", "electric"],
        settings: { audioEcho: true, audioDistortionLevel: 50, audioLowPassFreq: 3000, melodyInstrument: 'SAWTOOTH_LEAD', audioDelayTime: 0.1, audioDelayFeedback: 0.5 } 
    },
    { 
        name: "Deep Space", 
        category: "Experimental", 
        instrument: "PURE_SINE",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["vast", "empty", "low"],
        settings: { audioEcho: true, audioReverbLevel: 1.0, audioPitchShift: -24, melodyInstrument: 'PURE_SINE', audioDelayTime: 2.0, audioDelayFeedback: 0.6 } 
    },
    { 
        name: "Static Storm", 
        category: "Experimental", 
        instrument: "RAIN_FX",
        echoType: "NONE",
        clarity: "DISTORTED",
        tags: ["noise", "weather", "harsh"],
        settings: { audioEcho: false, audioDistortionLevel: 90, melodyInstrument: 'RAIN_FX' } 
    },
    { 
        name: "Wormhole", 
        category: "Experimental", 
        instrument: "SWEEP_PAD",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["travel", "space", "movement"],
        settings: { audioEcho: true, audioDelayTime: 0.1, audioDelayFeedback: 0.9, audioPitchShift: -12, melodyInstrument: 'SWEEP_PAD' } 
    },
    { 
        name: "Ghost in Shell", 
        category: "Experimental", 
        instrument: "SYNTH_VOICE",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["cyber", "vocal", "future"],
        settings: { audioEcho: true, audioReverbLevel: 0.6, audioDistortionLevel: 15, melodyInstrument: 'SYNTH_VOICE', audioDelayTime: 0.4, audioDelayFeedback: 0.5 } 
    },
    { 
        name: "Binary Sunset", 
        category: "Experimental", 
        instrument: "SQUARE_LEAD",
        echoType: "LONG",
        clarity: "CLEAR",
        tags: ["star wars", "digital", "peaceful"],
        settings: { audioEcho: true, audioDelayTime: 0.5, audioPitchShift: 7, melodyInstrument: 'SQUARE_LEAD', audioDelayFeedback: 0.6 } 
    },
    { 
        name: "Void Walker", 
        category: "Experimental", 
        instrument: "ATMOSPHERE_FX",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["empty", "dark", "slow"],
        settings: { audioEcho: true, audioReverbLevel: 0.8, audioLowPassFreq: 500, melodyInstrument: 'ATMOSPHERE_FX', audioDelayTime: 1.5, audioDelayFeedback: 0.7 } 
    },

    // NATURAL & ACOUSTIC
    { 
        name: "Clean Studio", 
        category: "Acoustic", 
        instrument: "GRAND_PIANO",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["pure", "piano", "simple"],
        settings: { audioEcho: false, audioReverbLevel: 0.1, audioDistortionLevel: 0, audioLowPassFreq: 20000, melodyInstrument: 'GRAND_PIANO' } 
    },
    { 
        name: "Bright Piano", 
        category: "Acoustic", 
        instrument: "BRIGHT_PIANO",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["pop", "piano", "happy"],
        settings: { audioEcho: false, audioReverbLevel: 0.2, melodyInstrument: 'BRIGHT_PIANO' } 
    },
    { 
        name: "Honky Tonk", 
        category: "Acoustic", 
        instrument: "HONKY_TONK",
        echoType: "NONE",
        clarity: "DISTORTED",
        tags: ["vintage", "piano", "detuned"],
        settings: { audioEcho: false, audioReverbLevel: 0.1, melodyInstrument: 'HONKY_TONK', audioDistortionLevel: 5 } 
    },
    { 
        name: "Harpsichord Baroque", 
        category: "Acoustic", 
        instrument: "HARPSICHORD",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["classic", "vintage", "pluck"],
        settings: { audioEcho: false, audioReverbLevel: 0.1, melodyInstrument: 'HARPSICHORD' } 
    },
    { 
        name: "Nylon Guitar", 
        category: "Acoustic", 
        instrument: "NYLON_GUITAR",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["soft", "guitar", "folk"],
        settings: { audioEcho: true, audioReverbLevel: 0.2, melodyInstrument: 'NYLON_GUITAR', audioDelayTime: 0.3, audioDelayFeedback: 0.2 } 
    },
    { 
        name: "Steel String", 
        category: "Acoustic", 
        instrument: "STEEL_GUITAR",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["bright", "guitar", "pop"],
        settings: { audioEcho: false, audioReverbLevel: 0.1, melodyInstrument: 'STEEL_GUITAR' } 
    },
    { 
        name: "Jazz Guitar", 
        category: "Acoustic", 
        instrument: "JAZZ_GUITAR",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["mellow", "guitar", "jazz"],
        settings: { audioEcho: true, audioReverbLevel: 0.3, melodyInstrument: 'JAZZ_GUITAR', audioDelayTime: 0.4, audioDelayFeedback: 0.3 } 
    },
    { 
        name: "Acoustic Bass", 
        category: "Acoustic", 
        instrument: "ACOUSTIC_BASS",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["low", "bass", "jazz"],
        settings: { audioEcho: false, audioReverbLevel: 0.1, melodyInstrument: 'ACOUSTIC_BASS', audioPitchShift: -12 } 
    },
    { 
        name: "Flute Meadow", 
        category: "Acoustic", 
        instrument: "FLUTE",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["nature", "wind", "soft"],
        settings: { audioEcho: true, audioReverbLevel: 0.4, melodyInstrument: 'FLUTE', audioDelayTime: 0.5, audioDelayFeedback: 0.4 } 
    },
    { 
        name: "Oboe Solo", 
        category: "Acoustic", 
        instrument: "OBOE",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["classical", "wind", "solemn"],
        settings: { audioEcho: true, audioReverbLevel: 0.3, melodyInstrument: 'OBOE', audioDelayTime: 0.3, audioDelayFeedback: 0.2 } 
    },
    { 
        name: "Clarinet Jazz", 
        category: "Acoustic", 
        instrument: "CLARINET",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["jazz", "wind", "mellow"],
        settings: { audioEcho: false, audioReverbLevel: 0.2, melodyInstrument: 'CLARINET' } 
    },
    { 
        name: "Recorder Song", 
        category: "Acoustic", 
        instrument: "RECORDER",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["school", "wind", "simple"],
        settings: { audioEcho: true, audioReverbLevel: 0.2, melodyInstrument: 'RECORDER', audioDelayTime: 0.2, audioDelayFeedback: 0.3 } 
    },
    { 
        name: "Pan Flute Journey", 
        category: "Acoustic", 
        instrument: "PAN_FLUTE",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["nature", "travel", "soft"],
        settings: { audioEcho: true, audioReverbLevel: 0.5, melodyInstrument: 'PAN_FLUTE', audioDelayTime: 0.8, audioDelayFeedback: 0.5 } 
    },
    { 
        name: "Banjo Pick", 
        category: "Acoustic", 
        instrument: "BANJO",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["folk", "fast", "pluck"],
        settings: { audioEcho: false, audioReverbLevel: 0.1, melodyInstrument: 'BANJO' } 
    },
    { 
        name: "Sitar Meditation", 
        category: "Acoustic", 
        instrument: "SITAR",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["india", "yoga", "strings"],
        settings: { audioEcho: true, audioReverbLevel: 0.6, melodyInstrument: 'SITAR', audioDelayTime: 1.0, audioDelayFeedback: 0.6 } 
    },

    // ROCK & METAL
    { 
        name: "Stadium Rock", 
        category: "Rock", 
        instrument: "CLEAN_GUITAR",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["live", "grand", "guitar"],
        settings: { audioEcho: true, audioReverbLevel: 0.4, audioDistortionLevel: 15, audioDelayTime: 0.2, audioDelayFeedback: 0.3, melodyInstrument: 'CLEAN_GUITAR' } 
    },
    { 
        name: "Heavy Metal", 
        category: "Rock", 
        instrument: "DISTORTION_GUITAR",
        echoType: "NONE",
        clarity: "DISTORTED",
        tags: ["metal", "loud", "guitar"],
        settings: { audioEcho: false, audioDistortionLevel: 80, audioReverbLevel: 0.1, melodyInstrument: 'DISTORTION_GUITAR' } 
    },
    { 
        name: "Overdriven Solo", 
        category: "Rock", 
        instrument: "OVERDRIVEN_GUITAR",
        echoType: "STEREO",
        clarity: "DISTORTED",
        tags: ["solo", "drive", "rock"],
        settings: { audioEcho: true, audioDistortionLevel: 40, audioDelayTime: 0.3, audioDelayFeedback: 0.4, melodyInstrument: 'OVERDRIVEN_GUITAR' } 
    },
    { 
        name: "Muted Chugs", 
        category: "Rock", 
        instrument: "MUTED_GUITAR",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["rhythm", "metal", "tight"],
        settings: { audioEcho: false, audioDistortionLevel: 20, melodyInstrument: 'MUTED_GUITAR' } 
    },
    { 
        name: "Rock Organ", 
        category: "Rock", 
        instrument: "ROCK_ORGAN",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["classic", "organ", "rock"],
        settings: { audioEcho: true, audioReverbLevel: 0.3, audioDistortionLevel: 10, melodyInstrument: 'ROCK_ORGAN', audioDelayTime: 0.2, audioDelayFeedback: 0.3 } 
    },
    { 
        name: "Slap Bass Funk", 
        category: "Rock", 
        instrument: "SLAP_BASS_1",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["funk", "bass", "slap"],
        settings: { audioEcho: false, audioDistortionLevel: 5, melodyInstrument: 'SLAP_BASS_1', audioPitchShift: -12 } 
    },
    { 
        name: "Power Chords", 
        category: "Rock", 
        instrument: "DISTORTION_GUITAR",
        echoType: "NONE",
        clarity: "DISTORTED",
        tags: ["punk", "heavy", "guitar"],
        settings: { audioEcho: false, audioDistortionLevel: 60, melodyInstrument: 'DISTORTION_GUITAR' } 
    },
    { 
        name: "Garage Band", 
        category: "Rock", 
        instrument: "CLEAN_GUITAR",
        echoType: "MONO",
        clarity: "DISTORTED",
        tags: ["raw", "indie", "rock"],
        settings: { audioEcho: true, audioDistortionLevel: 30, audioReverbLevel: 0.2, melodyInstrument: 'CLEAN_GUITAR', audioDelayTime: 0.1, audioDelayFeedback: 0.4 } 
    },
    { 
        name: "Punk Energy", 
        category: "Rock", 
        instrument: "OVERDRIVEN_GUITAR",
        echoType: "NONE",
        clarity: "DISTORTED",
        tags: ["fast", "punk", "raw"],
        settings: { audioEcho: false, audioDistortionLevel: 50, melodyInstrument: 'OVERDRIVEN_GUITAR' } 
    },
    { 
        name: "Blues Lead", 
        category: "Rock", 
        instrument: "CLEAN_GUITAR",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["blues", "warm", "guitar"],
        settings: { audioEcho: true, audioReverbLevel: 0.3, melodyInstrument: 'CLEAN_GUITAR', audioDelayTime: 0.3, audioDelayFeedback: 0.2 } 
    },
    { 
        name: "Metal Bass", 
        category: "Rock", 
        instrument: "PICK_BASS",
        echoType: "NONE",
        clarity: "DISTORTED",
        tags: ["heavy", "low", "bass"],
        settings: { audioEcho: false, audioDistortionLevel: 40, melodyInstrument: 'PICK_BASS', audioPitchShift: -12 } 
    },
    { 
        name: "Hard Rock", 
        category: "Rock", 
        instrument: "OVERDRIVEN_GUITAR",
        echoType: "SHORT",
        clarity: "DISTORTED",
        tags: ["classic", "heavy", "rock"],
        settings: { audioEcho: true, audioDistortionLevel: 25, audioDelayTime: 0.1, audioDelayFeedback: 0.3, melodyInstrument: 'OVERDRIVEN_GUITAR' } 
    },
    { 
        name: "Thrash", 
        category: "Rock", 
        instrument: "DISTORTION_GUITAR",
        echoType: "NONE",
        clarity: "DISTORTED",
        tags: ["fast", "metal", "aggressive"],
        settings: { audioEcho: false, audioDistortionLevel: 90, melodyInstrument: 'DISTORTION_GUITAR' } 
    },
    { 
        name: "Soft Rock", 
        category: "Rock", 
        instrument: "CLEAN_GUITAR",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["mellow", "pop", "rock"],
        settings: { audioEcho: true, audioReverbLevel: 0.2, melodyInstrument: 'CLEAN_GUITAR', audioDelayTime: 0.4, audioDelayFeedback: 0.3 } 
    },
    { 
        name: "Rockabilly", 
        category: "Rock", 
        instrument: "CLEAN_GUITAR",
        echoType: "SHORT",
        clarity: "CLEAR",
        tags: ["50s", "slapback", "guitar"],
        settings: { audioEcho: true, audioDelayTime: 0.1, audioDelayFeedback: 0.5, melodyInstrument: 'CLEAN_GUITAR' } 
    },

    // JAZZ & BLUES
    { 
        name: "Smooth Jazz", 
        category: "Jazz", 
        instrument: "TENOR_SAX",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["mellow", "sax", "cool"],
        settings: { audioEcho: true, audioReverbLevel: 0.3, melodyInstrument: 'TENOR_SAX', audioDelayTime: 0.4, audioDelayFeedback: 0.4 } 
    },
    { 
        name: "Blues Harp", 
        category: "Jazz", 
        instrument: "HARMONICA",
        echoType: "MONO",
        clarity: "DISTORTED",
        tags: ["blues", "raw", "harmonica"],
        settings: { audioEcho: true, audioReverbLevel: 0.2, melodyInstrument: 'HARMONICA', audioDelayTime: 0.2, audioDelayFeedback: 0.3 } 
    },
    { 
        name: "Jazz Club", 
        category: "Jazz", 
        instrument: "JAZZ_GUITAR",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["warm", "guitar", "jazz"],
        settings: { audioEcho: true, audioReverbLevel: 0.4, melodyInstrument: 'JAZZ_GUITAR', audioDelayTime: 0.3, audioDelayFeedback: 0.4 } 
    },
    { 
        name: "Walking Bass", 
        category: "Jazz", 
        instrument: "FINGER_BASS",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["swing", "low", "bass"],
        settings: { audioEcho: false, audioReverbLevel: 0.1, melodyInstrument: 'FINGER_BASS', audioPitchShift: -12 } 
    },
    { 
        name: "Trumpet Solo", 
        category: "Jazz", 
        instrument: "TRUMPET",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["bright", "brass", "jazz"],
        settings: { audioEcho: true, audioReverbLevel: 0.3, melodyInstrument: 'TRUMPET', audioDelayTime: 0.2, audioDelayFeedback: 0.3 } 
    },
    { 
        name: "Muted Jazz", 
        category: "Jazz", 
        instrument: "MUTED_TRUMPET",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["cool", "brass", "muted"],
        settings: { audioEcho: true, audioReverbLevel: 0.2, melodyInstrument: 'MUTED_TRUMPET', audioDelayTime: 0.3, audioDelayFeedback: 0.4 } 
    },
    { 
        name: "Saxophone Night", 
        category: "Jazz", 
        instrument: "ALTO_SAX",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["moody", "sax", "jazz"],
        settings: { audioEcho: true, audioReverbLevel: 0.5, melodyInstrument: 'ALTO_SAX', audioDelayTime: 0.6, audioDelayFeedback: 0.5 } 
    },
    { 
        name: "Jazz Piano", 
        category: "Jazz", 
        instrument: "GRAND_PIANO",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["classic", "piano", "jazz"],
        settings: { audioEcho: false, audioReverbLevel: 0.2, melodyInstrument: 'GRAND_PIANO' } 
    },
    { 
        name: "Vibes Lounge", 
        category: "Jazz", 
        instrument: "VIBRAPHONE",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["mellow", "metal", "jazz"],
        settings: { audioEcho: true, audioReverbLevel: 0.4, melodyInstrument: 'VIBRAPHONE', audioDelayTime: 0.4, audioDelayFeedback: 0.5 } 
    },
    { 
        name: "Organ Groove", 
        category: "Jazz", 
        instrument: "DRAWBAR_ORGAN",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["soul", "organ", "warm"],
        settings: { audioEcho: true, audioReverbLevel: 0.2, melodyInstrument: 'DRAWBAR_ORGAN', audioDelayTime: 0.3, audioDelayFeedback: 0.4 } 
    },
    { 
        name: "Trombone Slide", 
        category: "Jazz", 
        instrument: "TROMBONE",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["brass", "low", "jazz"],
        settings: { audioEcho: false, audioReverbLevel: 0.2, melodyInstrument: 'TROMBONE' } 
    },
    { 
        name: "Clarinet Swing", 
        category: "Jazz", 
        instrument: "CLARINET",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["swing", "wind", "jazz"],
        settings: { audioEcho: false, audioReverbLevel: 0.1, melodyInstrument: 'CLARINET' } 
    },
    { 
        name: "Fretless Magic", 
        category: "Jazz", 
        instrument: "FRETLESS_BASS",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["smooth", "low", "bass"],
        settings: { audioEcho: true, audioReverbLevel: 0.3, melodyInstrument: 'FRETLESS_BASS', audioPitchShift: -12, audioDelayTime: 0.4, audioDelayFeedback: 0.3 } 
    },
    { 
        name: "Jazz Brass", 
        category: "Jazz", 
        instrument: "BRASS_SECTION",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["big band", "brass", "jazz"],
        settings: { audioEcho: true, audioReverbLevel: 0.3, melodyInstrument: 'BRASS_SECTION', audioDelayTime: 0.2, audioDelayFeedback: 0.3 } 
    },
    { 
        name: "Midnight Sax", 
        category: "Jazz", 
        instrument: "TENOR_SAX",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["dark", "sax", "jazz"],
        settings: { audioEcho: true, audioReverbLevel: 0.6, melodyInstrument: 'TENOR_SAX', audioDelayTime: 0.8, audioDelayFeedback: 0.5 } 
    },

    // WORLD & ETHNIC
    { 
        name: "Sitar Sunrise", 
        category: "World", 
        instrument: "SITAR",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["india", "morning", "strings"],
        settings: { audioEcho: true, audioReverbLevel: 0.5, melodyInstrument: 'SITAR', audioDelayTime: 0.8, audioDelayFeedback: 0.6 } 
    },
    { 
        name: "Banjo Creek", 
        category: "World", 
        instrument: "BANJO",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["bluegrass", "folk", "pluck"],
        settings: { audioEcho: false, audioReverbLevel: 0.1, melodyInstrument: 'BANJO' } 
    },
    { 
        name: "Koto Zen", 
        category: "World", 
        instrument: "KOTO",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["japan", "peaceful", "strings"],
        settings: { audioEcho: true, audioReverbLevel: 0.4, melodyInstrument: 'KOTO', audioDelayTime: 0.4, audioDelayFeedback: 0.4 } 
    },
    { 
        name: "Shamisen Spirit", 
        category: "World", 
        instrument: "SHAMISEN",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["japan", "energy", "strings"],
        settings: { audioEcho: false, audioReverbLevel: 0.2, melodyInstrument: 'SHAMISEN' } 
    },
    { 
        name: "Kalimba Rain", 
        category: "World", 
        instrument: "KALIMBA",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["soft", "percussion", "africa"],
        settings: { audioEcho: true, audioReverbLevel: 0.3, melodyInstrument: 'KALIMBA', audioDelayTime: 0.2, audioDelayFeedback: 0.6 } 
    },
    { 
        name: "Bagpipe Highlands", 
        category: "World", 
        instrument: "BAGPIPE",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["scotland", "loud", "wind"],
        settings: { audioEcho: true, audioReverbLevel: 0.4, melodyInstrument: 'BAGPIPE', audioDelayTime: 0.5, audioDelayFeedback: 0.3 } 
    },
    { 
        name: "Shakuhachi Mist", 
        category: "World", 
        instrument: "SHAKUHACHI",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["japan", "zen", "wind"],
        settings: { audioEcho: true, audioReverbLevel: 0.7, melodyInstrument: 'SHAKUHACHI', audioDelayTime: 1.0, audioDelayFeedback: 0.5 } 
    },
    { 
        name: "Shanai Festival", 
        category: "World", 
        instrument: "SHANAI",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["india", "celebration", "wind"],
        settings: { audioEcho: true, audioReverbLevel: 0.3, melodyInstrument: 'SHANAI', audioDelayTime: 0.3, audioDelayFeedback: 0.4 } 
    },
    { 
        name: "Accordion Street", 
        category: "World", 
        instrument: "ACCORDION",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["paris", "folk", "wind"],
        settings: { audioEcho: false, audioReverbLevel: 0.2, melodyInstrument: 'ACCORDION' } 
    },
    { 
        name: "Harmonica Blues", 
        category: "World", 
        instrument: "HARMONICA",
        echoType: "STEREO",
        clarity: "DISTORTED",
        tags: ["blues", "raw", "wind"],
        settings: { audioEcho: true, audioReverbLevel: 0.2, melodyInstrument: 'HARMONICA', audioDelayTime: 0.2, audioDelayFeedback: 0.3 } 
    },
    { 
        name: "Tango Night", 
        category: "World", 
        instrument: "TANGO_ACCORDION",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["dance", "passion", "wind"],
        settings: { audioEcho: true, audioReverbLevel: 0.4, melodyInstrument: 'TANGO_ACCORDION', audioDelayTime: 0.4, audioDelayFeedback: 0.4 } 
    },
    { 
        name: "Fiddle Jig", 
        category: "World", 
        instrument: "FIDDLE",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["fast", "folk", "strings"],
        settings: { audioEcho: false, audioReverbLevel: 0.1, melodyInstrument: 'FIDDLE' } 
    },
    { 
        name: "Taiko Drums", 
        category: "World", 
        instrument: "TAIKO_DRUM",
        echoType: "NONE",
        clarity: "AMBIENT",
        tags: ["japan", "power", "drums"],
        settings: { audioEcho: false, audioReverbLevel: 0.5, melodyInstrument: 'TAIKO_DRUM' } 
    },
    { 
        name: "Pan Flute Dream", 
        category: "World", 
        instrument: "PAN_FLUTE",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["nature", "soft", "wind"],
        settings: { audioEcho: true, audioReverbLevel: 0.6, melodyInstrument: 'PAN_FLUTE', audioDelayTime: 0.8, audioDelayFeedback: 0.5 } 
    },
    { 
        name: "Steel Drum Island", 
        category: "World", 
        instrument: "STEEL_DRUMS",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["caribbean", "happy", "metal"],
        settings: { audioEcho: true, audioReverbLevel: 0.3, melodyInstrument: 'STEEL_DRUMS', audioDelayTime: 0.3, audioDelayFeedback: 0.4 } 
    },

    // CINEMATIC & SOUNDTRACK
    { 
        name: "Inception Braam", 
        category: "Cinematic", 
        instrument: "BRASS_SECTION",
        echoType: "NONE",
        clarity: "DISTORTED",
        tags: ["epic", "low", "impact"],
        settings: { audioDistortionLevel: 40, audioPitchShift: -12, melodyInstrument: 'BRASS_SECTION', audioLowPassFreq: 800 } 
    },
    { 
        name: "Interstellar Organ", 
        category: "Cinematic", 
        instrument: "CHURCH_ORGAN",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["space", "grand", "organ"],
        settings: { audioReverbLevel: 0.9, melodyInstrument: 'CHURCH_ORGAN', audioDelayTime: 0.8, audioDelayFeedback: 0.4, audioEcho: true } 
    },
    { 
        name: "Blade Runner", 
        category: "Cinematic", 
        instrument: "SAWTOOTH_LEAD",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["cyberpunk", "synth", "future"],
        settings: { audioEcho: true, audioReverbLevel: 0.7, melodyInstrument: 'SAWTOOTH_LEAD', audioLowPassFreq: 1200, audioLowPassResonance: 4.0, audioDelayTime: 0.4, audioDelayFeedback: 0.5 } 
    },
    { 
        name: "Hans Zimmer Horns", 
        category: "Cinematic", 
        instrument: "FRENCH_HORN",
        echoType: "NONE",
        clarity: "AMBIENT",
        tags: ["epic", "orchestral", "brass"],
        settings: { audioReverbLevel: 0.6, melodyInstrument: 'FRENCH_HORN', audioPitchShift: -5 } 
    },
    { 
        name: "Suspense Strings", 
        category: "Cinematic", 
        instrument: "TREMOLO_STRINGS",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["tension", "horror", "strings"],
        settings: { audioReverbLevel: 0.8, melodyInstrument: 'TREMOLO_STRINGS', audioEcho: true, audioDelayTime: 0.1, audioDelayFeedback: 0.2 } 
    },
    { 
        name: "Heroic Fanfare", 
        category: "Cinematic", 
        instrument: "TRUMPET",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["hero", "victory", "brass"],
        settings: { audioReverbLevel: 0.4, melodyInstrument: 'TRUMPET', audioEcho: true, audioDelayTime: 0.2, audioDelayFeedback: 0.3 } 
    },
    { 
        name: "Mystery Flute", 
        category: "Cinematic", 
        instrument: "PAN_FLUTE",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["mysterious", "nature", "wind"],
        settings: { audioReverbLevel: 0.7, audioDelayTime: 0.6, melodyInstrument: 'PAN_FLUTE', audioEcho: true, audioDelayFeedback: 0.5 } 
    },
    { 
        name: "Epic Percussion", 
        category: "Cinematic", 
        instrument: "TAIKO_DRUM",
        echoType: "NONE",
        clarity: "AMBIENT",
        tags: ["drums", "power", "impact"],
        settings: { audioReverbLevel: 0.5, melodyInstrument: 'TAIKO_DRUM', audioPitchShift: -12 } 
    },
    { 
        name: "Sci-Fi Pulse", 
        category: "Cinematic", 
        instrument: "SQUARE_LEAD",
        echoType: "SHORT",
        clarity: "CLEAR",
        tags: ["tech", "pulse", "future"],
        settings: { audioEcho: true, audioDelayTime: 0.125, melodyInstrument: 'SQUARE_LEAD', audioDelayFeedback: 0.4 } 
    },
    { 
        name: "Dystopian Future", 
        category: "Cinematic", 
        instrument: "SYNTH_BASS_2",
        echoType: "NONE",
        clarity: "DISTORTED",
        tags: ["dark", "future", "bass"],
        settings: { audioDistortionLevel: 20, audioReverbLevel: 0.8, melodyInstrument: 'SYNTH_BASS_2' } 
    },

    // RETRO GAMING
    { 
        name: "Mega Man Buster", 
        category: "Retro", 
        instrument: "SQUARE_LEAD",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["8bit", "action", "shoot"],
        settings: { audioDistortionLevel: 10, melodyInstrument: 'SQUARE_LEAD' } 
    },
    { 
        name: "Castlevania Organ", 
        category: "Retro", 
        instrument: "CHURCH_ORGAN",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["gothic", "8bit", "organ"],
        settings: { audioReverbLevel: 0.4, melodyInstrument: 'CHURCH_ORGAN', audioPitchShift: 12, audioEcho: true, audioDelayTime: 0.2, audioDelayFeedback: 0.3 } 
    },
    { 
        name: "Zelda Secret", 
        category: "Retro", 
        instrument: "GLOCKENSPIEL",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["discovery", "8bit", "bells"],
        settings: { audioReverbLevel: 0.3, melodyInstrument: 'GLOCKENSPIEL' } 
    },
    { 
        name: "Mario Jump", 
        category: "Retro", 
        instrument: "PURE_SINE",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["jump", "8bit", "classic"],
        settings: { audioPitchShift: 12, melodyInstrument: 'PURE_SINE' } 
    },
    { 
        name: "Sonic Ring", 
        category: "Retro", 
        instrument: "TINKLE_BELL",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["collect", "8bit", "bells"],
        settings: { audioReverbLevel: 0.2, melodyInstrument: 'TINKLE_BELL' } 
    },
    { 
        name: "Pac-Man Death", 
        category: "Retro", 
        instrument: "SAWTOOTH_LEAD",
        echoType: "NONE",
        clarity: "DISTORTED",
        tags: ["game over", "8bit", "classic"],
        settings: { audioPitchShift: -24, melodyInstrument: 'SAWTOOTH_LEAD' } 
    },
    { 
        name: "Tetris Theme", 
        category: "Retro", 
        instrument: "8BIT_LEAD",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["puzzle", "8bit", "classic"],
        settings: { audioDistortionLevel: 5, melodyInstrument: '8BIT_LEAD' } 
    },
    { 
        name: "Pokemon Center", 
        category: "Retro", 
        instrument: "CELESTA",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["heal", "8bit", "peaceful"],
        settings: { audioReverbLevel: 0.3, melodyInstrument: 'CELESTA', audioEcho: true, audioDelayTime: 0.4, audioDelayFeedback: 0.2 } 
    },
    { 
        name: "Final Fantasy Victory", 
        category: "Retro", 
        instrument: "TRUMPET",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["victory", "8bit", "brass"],
        settings: { audioReverbLevel: 0.5, melodyInstrument: 'TRUMPET', audioEcho: true, audioDelayTime: 0.2, audioDelayFeedback: 0.3 } 
    },
    { 
        name: "Donkey Kong Jungle", 
        category: "Retro", 
        instrument: "MARIMBA",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["jungle", "8bit", "percussion"],
        settings: { audioReverbLevel: 0.2, melodyInstrument: 'MARIMBA' } 
    },

    // MODERN ELECTRONIC
    { 
        name: "Skrillex Growl", 
        category: "Electronic", 
        instrument: "SYNTH_BASS_2",
        echoType: "NONE",
        clarity: "DISTORTED",
        tags: ["dubstep", "heavy", "bass"],
        settings: { audioDistortionLevel: 80, audioLowPassFreq: 1500, audioLowPassResonance: 15.0, melodyInstrument: 'SYNTH_BASS_2' } 
    },
    { 
        name: "Daft Punk Vocoder", 
        category: "Electronic", 
        instrument: "SYNTH_VOICE",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["french house", "vocal", "robot"],
        settings: { audioDistortionLevel: 30, melodyInstrument: 'SYNTH_VOICE', audioEcho: true, audioDelayTime: 0.2, audioDelayFeedback: 0.3 } 
    },
    { 
        name: "Avicii Lead", 
        category: "Electronic", 
        instrument: "SYNTH_BRASS_1",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["edm", "happy", "lead"],
        settings: { audioReverbLevel: 0.3, melodyInstrument: 'SYNTH_BRASS_1', audioEcho: true, audioDelayTime: 0.3, audioDelayFeedback: 0.4 } 
    },
    { 
        name: "Deadmau5 Pluck", 
        category: "Electronic", 
        instrument: "SYNTH_PLUCK",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["progressive", "pluck", "house"],
        settings: { audioDelayTime: 0.375, melodyInstrument: 'SYNTH_PLUCK', audioEcho: true, audioDelayFeedback: 0.5 } 
    },
    { 
        name: "Marshmello Synth", 
        category: "Electronic", 
        instrument: "SQUARE_LEAD",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["pop", "bright", "lead"],
        settings: { audioReverbLevel: 0.4, melodyInstrument: 'SQUARE_LEAD', audioEcho: true, audioDelayTime: 0.2, audioDelayFeedback: 0.3 } 
    },
    { 
        name: "Flume Granular", 
        category: "Electronic", 
        instrument: "ATMOSPHERE_FX",
        echoType: "SHORT",
        clarity: "AMBIENT",
        tags: ["future bass", "glitch", "texture"],
        settings: { audioEcho: true, audioDelayTime: 0.05, melodyInstrument: 'ATMOSPHERE_FX', audioDelayFeedback: 0.8 } 
    },
    { 
        name: "Tiesto Trance", 
        category: "Electronic", 
        instrument: "SAWTOOTH_LEAD",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["trance", "epic", "lead"],
        settings: { audioDelayTime: 0.375, audioDelayFeedback: 0.6, melodyInstrument: 'SAWTOOTH_LEAD', audioEcho: true } 
    },
    { 
        name: "Aphex Twin Glitch", 
        category: "Electronic", 
        instrument: "8BIT_LEAD",
        echoType: "SHORT",
        clarity: "DISTORTED",
        tags: ["idm", "glitch", "experimental"],
        settings: { audioDistortionLevel: 50, audioDelayTime: 0.01, melodyInstrument: '8BIT_LEAD', audioEcho: true, audioDelayFeedback: 0.9 } 
    },
    { 
        name: "Justice Distortion", 
        category: "Electronic", 
        instrument: "OVERDRIVEN_GUITAR",
        echoType: "NONE",
        clarity: "DISTORTED",
        tags: ["french house", "heavy", "drive"],
        settings: { audioDistortionLevel: 90, melodyInstrument: 'OVERDRIVEN_GUITAR' } 
    },
    { 
        name: "Kygo Tropical", 
        category: "Electronic", 
        instrument: "PAN_FLUTE",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["tropical", "happy", "soft"],
        settings: { audioReverbLevel: 0.2, melodyInstrument: 'PAN_FLUTE', audioEcho: true, audioDelayTime: 0.4, audioDelayFeedback: 0.3 } 
    },

    // NATURE & AMBIENT
    { 
        name: "Rainy Night", 
        category: "Nature", 
        instrument: "RAIN_FX",
        echoType: "NONE",
        clarity: "AMBIENT",
        tags: ["rain", "relax", "weather"],
        settings: { audioReverbLevel: 0.7, melodyInstrument: 'RAIN_FX' } 
    },
    { 
        name: "Ocean Waves", 
        category: "Nature", 
        instrument: "ATMOSPHERE_FX",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["sea", "calm", "nature"],
        settings: { audioReverbLevel: 0.9, melodyInstrument: 'ATMOSPHERE_FX', audioEcho: true, audioDelayTime: 1.5, audioDelayFeedback: 0.6 } 
    },
    { 
        name: "Forest Birds", 
        category: "Nature", 
        instrument: "WHISTLE",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["birds", "nature", "morning"],
        settings: { audioReverbLevel: 0.4, melodyInstrument: 'WHISTLE', audioEcho: true, audioDelayTime: 0.3, audioDelayFeedback: 0.4 } 
    },
    { 
        name: "Thunderstorm", 
        category: "Nature", 
        instrument: "TIMPANI",
        echoType: "NONE",
        clarity: "AMBIENT",
        tags: ["thunder", "power", "nature"],
        settings: { audioDistortionLevel: 20, melodyInstrument: 'TIMPANI', audioPitchShift: -12 } 
    },
    { 
        name: "Mountain Stream", 
        category: "Nature", 
        instrument: "CRYSTAL_FX",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["water", "pure", "nature"],
        settings: { audioReverbLevel: 0.5, melodyInstrument: 'CRYSTAL_FX', audioEcho: true, audioDelayTime: 0.1, audioDelayFeedback: 0.8 } 
    },
    { 
        name: "Desert Wind", 
        category: "Nature", 
        instrument: "HALO_PAD",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["wind", "vast", "empty"],
        settings: { audioReverbLevel: 0.8, melodyInstrument: 'HALO_PAD', audioLowPassFreq: 1000 } 
    },
    { 
        name: "Jungle Morning", 
        category: "Nature", 
        instrument: "OCARINA",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["nature", "birds", "wind"],
        settings: { audioReverbLevel: 0.3, melodyInstrument: 'OCARINA', audioEcho: true, audioDelayTime: 0.4, audioDelayFeedback: 0.4 } 
    },
    { 
        name: "Deep Cave", 
        category: "Nature", 
        instrument: "PURE_SINE",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["echo", "dark", "empty"],
        settings: { audioEcho: true, audioDelayTime: 0.8, melodyInstrument: 'PURE_SINE', audioReverbLevel: 0.9, audioDelayFeedback: 0.7 } 
    },
    { 
        name: "Arctic Tundra", 
        category: "Nature", 
        instrument: "NEW_AGE_PAD",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["cold", "vast", "empty"],
        settings: { audioReverbLevel: 1.0, melodyInstrument: 'NEW_AGE_PAD' } 
    },
    { 
        name: "Volcanic Ash", 
        category: "Nature", 
        instrument: "SOUNDTRACK_FX",
        echoType: "NONE",
        clarity: "DISTORTED",
        tags: ["dark", "fire", "danger"],
        settings: { audioDistortionLevel: 10, melodyInstrument: 'SOUNDTRACK_FX', audioLowPassFreq: 500 } 
    },

    // PERCUSSIVE & RHYTHMIC
    { 
        name: "Techno Kick", 
        category: "Percussive", 
        instrument: "SYNTH_DRUM",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["beat", "club", "low"],
        settings: { audioPitchShift: -24, melodyInstrument: 'SYNTH_DRUM' } 
    },
    { 
        name: "Snare Snap", 
        category: "Percussive", 
        instrument: "WOODBLOCK",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["beat", "sharp", "percussion"],
        settings: { audioDistortionLevel: 10, melodyInstrument: 'WOODBLOCK' } 
    },
    { 
        name: "Hi-Hat Tick", 
        category: "Percussive", 
        instrument: "TINKLE_BELL",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["beat", "high", "percussion"],
        settings: { audioHighPassFreq: 8000, melodyInstrument: 'TINKLE_BELL' } 
    },
    { 
        name: "Bongo Beat", 
        category: "Percussive", 
        instrument: "MELODIC_TOM",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["tribal", "hand", "drums"],
        settings: { audioReverbLevel: 0.1, melodyInstrument: 'MELODIC_TOM' } 
    },
    { 
        name: "Conga Groove", 
        category: "Percussive", 
        instrument: "AGOGO",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["latin", "hand", "percussion"],
        settings: { audioReverbLevel: 0.2, melodyInstrument: 'AGOGO' } 
    },
    { 
        name: "Cowbell Fever", 
        category: "Percussive", 
        instrument: "AGOGO",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["classic", "metal", "percussion"],
        settings: { audioReverbLevel: 0.1, melodyInstrument: 'AGOGO', audioPitchShift: 12 } 
    },
    { 
        name: "Shaker Shine", 
        category: "Percussive", 
        instrument: "RAIN_FX",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["soft", "texture", "percussion"],
        settings: { audioHighPassFreq: 5000, melodyInstrument: 'RAIN_FX' } 
    },
    { 
        name: "Clap Back", 
        category: "Percussive", 
        instrument: "WOODBLOCK",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["beat", "group", "percussion"],
        settings: { audioReverbLevel: 0.3, melodyInstrument: 'WOODBLOCK', audioEcho: true, audioDelayTime: 0.05, audioDelayFeedback: 0.4 } 
    },
    { 
        name: "Rimshot", 
        category: "Percussive", 
        instrument: "WOODBLOCK",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["beat", "tight", "percussion"],
        settings: { audioReverbLevel: 0.05, melodyInstrument: 'WOODBLOCK', audioPitchShift: 7 } 
    },
    { 
        name: "Cymbal Crash", 
        category: "Percussive", 
        instrument: "REVERSE_CYMBAL",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["impact", "metal", "percussion"],
        settings: { audioReverbLevel: 0.6, melodyInstrument: 'REVERSE_CYMBAL' } 
    },

    // SYNTH LEADS & PADS
    { 
        name: "Super Saw", 
        category: "Synth", 
        instrument: "SAWTOOTH_LEAD",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["bright", "lead", "edm"],
        settings: { audioReverbLevel: 0.4, melodyInstrument: 'SAWTOOTH_LEAD', audioEcho: true, audioDelayTime: 0.3, audioDelayFeedback: 0.4 } 
    },
    { 
        name: "Square Lead", 
        category: "Synth", 
        instrument: "SQUARE_LEAD",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["8bit", "digital", "lead"],
        settings: { audioDistortionLevel: 5, melodyInstrument: 'SQUARE_LEAD' } 
    },
    { 
        name: "Sine Lead", 
        category: "Synth", 
        instrument: "PURE_SINE",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["pure", "soft", "lead"],
        settings: { audioReverbLevel: 0.2, melodyInstrument: 'PURE_SINE', audioEcho: true, audioDelayTime: 0.4, audioDelayFeedback: 0.3 } 
    },
    { 
        name: "Triangle Lead", 
        category: "Synth", 
        instrument: "SQUARE_LEAD",
        echoType: "SHORT",
        clarity: "CLEAR",
        tags: ["soft", "digital", "lead"],
        settings: { audioReverbLevel: 0.3, melodyInstrument: 'SQUARE_LEAD', audioLowPassFreq: 2000 } 
    },
    { 
        name: "Pulse Width", 
        category: "Synth", 
        instrument: "SAWTOOTH_LEAD",
        echoType: "NONE",
        clarity: "DISTORTED",
        tags: ["buzz", "analog", "lead"],
        settings: { audioDistortionLevel: 20, melodyInstrument: 'SAWTOOTH_LEAD' } 
    },
    { 
        name: "Warm Pad", 
        category: "Synth", 
        instrument: "WARM_PAD",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["soft", "warm", "pad"],
        settings: { audioReverbLevel: 0.8, melodyInstrument: 'WARM_PAD' } 
    },
    { 
        name: "Bright Pad", 
        category: "Synth", 
        instrument: "NEW_AGE_PAD",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["bright", "sparkle", "pad"],
        settings: { audioReverbLevel: 0.6, melodyInstrument: 'NEW_AGE_PAD', audioEcho: true, audioDelayTime: 0.5, audioDelayFeedback: 0.4 } 
    },
    { 
        name: "Dark Pad", 
        category: "Synth", 
        instrument: "HALO_PAD",
        echoType: "NONE",
        clarity: "MUFFLED",
        tags: ["dark", "low", "pad"],
        settings: { audioLowPassFreq: 800, melodyInstrument: 'HALO_PAD', audioReverbLevel: 0.7 } 
    },
    { 
        name: "Evolving Pad", 
        category: "Synth", 
        instrument: "SWEEP_PAD",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["movement", "vast", "pad"],
        settings: { audioEcho: true, audioDelayTime: 1.0, melodyInstrument: 'SWEEP_PAD', audioReverbLevel: 0.8, audioDelayFeedback: 0.6 } 
    },
    { 
        name: "Vocal Pad", 
        category: "Synth", 
        instrument: "CHOIR_PAD",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["vocal", "soft", "pad"],
        settings: { audioReverbLevel: 0.7, melodyInstrument: 'CHOIR_PAD', audioEcho: true, audioDelayTime: 0.6, audioDelayFeedback: 0.5 } 
    },

    // EXPERIMENTAL & GLITCH
    { 
        name: "Bit Crusher", 
        category: "Experimental", 
        instrument: "8BIT_LEAD",
        echoType: "NONE",
        clarity: "DISTORTED",
        tags: ["lo-fi", "broken", "digital"],
        settings: { audioDistortionLevel: 100, melodyInstrument: '8BIT_LEAD' } 
    },
    { 
        name: "Ring Mod", 
        category: "Experimental", 
        instrument: "PURE_SINE",
        echoType: "SHORT",
        clarity: "DISTORTED",
        tags: ["metallic", "weird", "experimental"],
        settings: { audioDelayTime: 0.01, audioDelayFeedback: 0.9, melodyInstrument: 'PURE_SINE', audioEcho: true } 
    },
    { 
        name: "Frequency Mod", 
        category: "Experimental", 
        instrument: "SAWTOOTH_LEAD",
        echoType: "SHORT",
        clarity: "DISTORTED",
        tags: ["harsh", "digital", "experimental"],
        settings: { audioDelayTime: 0.005, audioDelayFeedback: 0.8, melodyInstrument: 'SAWTOOTH_LEAD', audioEcho: true } 
    },
    { 
        name: "Glitch Delay", 
        category: "Experimental", 
        instrument: "SYNTH_PLUCK",
        echoType: "SHORT",
        clarity: "CLEAR",
        tags: ["glitch", "tech", "experimental"],
        settings: { audioEcho: true, audioDelayTime: 0.05, melodyInstrument: 'SYNTH_PLUCK', audioDelayFeedback: 0.9 } 
    },
    { 
        name: "Reverse Echo", 
        category: "Experimental", 
        instrument: "REVERSE_CYMBAL",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["reverse", "ghostly", "experimental"],
        settings: { audioEcho: true, audioDelayTime: 0.5, audioDelayFeedback: 0.7, melodyInstrument: 'REVERSE_CYMBAL' } 
    },
    { 
        name: "Stutter Step", 
        category: "Experimental", 
        instrument: "8BIT_LEAD",
        echoType: "SHORT",
        clarity: "CLEAR",
        tags: ["stutter", "rhythmic", "experimental"],
        settings: { audioDelayTime: 0.1, audioDelayFeedback: 0.9, melodyInstrument: '8BIT_LEAD', audioEcho: true } 
    },
    { 
        name: "Noise Burst", 
        category: "Experimental", 
        instrument: "RAIN_FX",
        echoType: "NONE",
        clarity: "DISTORTED",
        tags: ["noise", "harsh", "experimental"],
        settings: { audioDistortionLevel: 100, melodyInstrument: 'RAIN_FX' } 
    },
    { 
        name: "Ghost Echo", 
        category: "Experimental", 
        instrument: "ECHOES_FX",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["ghostly", "vast", "experimental"],
        settings: { audioReverbLevel: 1.0, audioDelayTime: 1.2, melodyInstrument: 'ECHOES_FX', audioEcho: true, audioDelayFeedback: 0.8 } 
    },
    { 
        name: "Alien Chatter", 
        category: "Experimental", 
        instrument: "GOBLINS_FX",
        echoType: "SHORT",
        clarity: "DISTORTED",
        tags: ["alien", "weird", "experimental"],
        settings: { audioDelayTime: 0.02, audioPitchShift: 12, melodyInstrument: 'GOBLINS_FX', audioEcho: true, audioDelayFeedback: 0.7 } 
    },
    { 
        name: "Data Corruption", 
        category: "Experimental", 
        instrument: "8BIT_LEAD",
        echoType: "SHORT",
        clarity: "DISTORTED",
        tags: ["broken", "digital", "experimental"],
        settings: { audioDistortionLevel: 80, audioPitchShift: -5, melodyInstrument: '8BIT_LEAD', audioEcho: true, audioDelayTime: 0.01, audioDelayFeedback: 0.9 } 
    },

    // ORCHESTRAL ENSEMBLES
    { 
        name: "Full Orchestra", 
        category: "Orchestral", 
        instrument: "STRING_ENSEMBLE_1",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["epic", "grand", "orchestra"],
        settings: { audioReverbLevel: 0.7, melodyInstrument: 'STRING_ENSEMBLE_1', audioEcho: true, audioDelayTime: 0.3, audioDelayFeedback: 0.3 } 
    },
    { 
        name: "String Quartet", 
        category: "Orchestral", 
        instrument: "VIOLIN",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["classic", "strings", "small"],
        settings: { audioReverbLevel: 0.4, melodyInstrument: 'VIOLIN' } 
    },
    { 
        name: "Brass Quintet", 
        category: "Orchestral", 
        instrument: "BRASS_SECTION",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["classic", "brass", "small"],
        settings: { audioReverbLevel: 0.5, melodyInstrument: 'BRASS_SECTION', audioEcho: true, audioDelayTime: 0.2, audioDelayFeedback: 0.3 } 
    },
    { 
        name: "Woodwind Trio", 
        category: "Orchestral", 
        instrument: "FLUTE",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["classic", "wind", "small"],
        settings: { audioReverbLevel: 0.3, melodyInstrument: 'FLUTE' } 
    },
    { 
        name: "Chamber Music", 
        category: "Orchestral", 
        instrument: "CELLO",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["classic", "strings", "mellow"],
        settings: { audioReverbLevel: 0.4, melodyInstrument: 'CELLO', audioEcho: true, audioDelayTime: 0.4, audioDelayFeedback: 0.2 } 
    },
    { 
        name: "Symphonic Hall", 
        category: "Orchestral", 
        instrument: "STRING_ENSEMBLE_2",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["epic", "vast", "orchestra"],
        settings: { audioReverbLevel: 0.9, melodyInstrument: 'STRING_ENSEMBLE_2', audioEcho: true, audioDelayTime: 0.8, audioDelayFeedback: 0.4 } 
    },
    { 
        name: "Opera Stage", 
        category: "Orchestral", 
        instrument: "CHOIR_AAHS",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["vocal", "grand", "opera"],
        settings: { audioReverbLevel: 0.8, melodyInstrument: 'CHOIR_AAHS', audioEcho: true, audioDelayTime: 1.0, audioDelayFeedback: 0.5 } 
    },
    { 
        name: "Cathedral Organ", 
        category: "Orchestral", 
        instrument: "CHURCH_ORGAN",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["sacred", "grand", "organ"],
        settings: { audioReverbLevel: 1.0, melodyInstrument: 'CHURCH_ORGAN', audioEcho: true, audioDelayTime: 1.2, audioDelayFeedback: 0.6 } 
    },
    { 
        name: "Royal Fanfare", 
        category: "Orchestral", 
        instrument: "TRUMPET",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["victory", "brass", "royal"],
        settings: { audioReverbLevel: 0.5, melodyInstrument: 'TRUMPET', audioEcho: true, audioDelayTime: 0.2, audioDelayFeedback: 0.3 } 
    },
    { 
        name: "Ancient Harp", 
        category: "Orchestral", 
        instrument: "ORCHESTRAL_HARP",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["soft", "mythical", "strings"],
        settings: { audioReverbLevel: 0.6, melodyInstrument: 'ORCHESTRAL_HARP', audioEcho: true, audioDelayTime: 0.5, audioDelayFeedback: 0.4 } 
    },

    // ACOUSTIC INSTRUMENTS
    { 
        name: "Grand Piano", 
        category: "Acoustic", 
        instrument: "GRAND_PIANO",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["classic", "piano", "pure"],
        settings: { audioReverbLevel: 0.2, melodyInstrument: 'GRAND_PIANO' } 
    },
    { 
        name: "Upright Piano", 
        category: "Acoustic", 
        instrument: "BRIGHT_PIANO",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["pop", "piano", "bright"],
        settings: { audioReverbLevel: 0.1, melodyInstrument: 'BRIGHT_PIANO' } 
    },
    { 
        name: "Acoustic Guitar", 
        category: "Acoustic", 
        instrument: "NYLON_GUITAR",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["soft", "guitar", "folk"],
        settings: { audioReverbLevel: 0.2, melodyInstrument: 'NYLON_GUITAR', audioEcho: true, audioDelayTime: 0.3, audioDelayFeedback: 0.2 } 
    },
    { 
        name: "Acoustic Steel", 
        category: "Acoustic", 
        instrument: "STEEL_GUITAR",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["bright", "guitar", "pop"],
        settings: { audioReverbLevel: 0.1, melodyInstrument: 'STEEL_GUITAR' } 
    },
    { 
        name: "Double Bass", 
        category: "Acoustic", 
        instrument: "ACOUSTIC_BASS",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["low", "bass", "jazz"],
        settings: { audioReverbLevel: 0.1, melodyInstrument: 'ACOUSTIC_BASS', audioPitchShift: -12 } 
    },
    { 
        name: "Cello Solo", 
        category: "Acoustic", 
        instrument: "CELLO",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["classic", "strings", "mellow"],
        settings: { audioReverbLevel: 0.4, melodyInstrument: 'CELLO', audioEcho: true, audioDelayTime: 0.4, audioDelayFeedback: 0.3 } 
    },
    { 
        name: "Violin Recital", 
        category: "Orchestral", 
        instrument: "VIOLIN",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["classic", "strings", "high"],
        settings: { audioReverbLevel: 0.3, melodyInstrument: 'VIOLIN', audioEcho: true, audioDelayTime: 0.2, audioDelayFeedback: 0.3 } 
    },
    { 
        name: "Flute Solo", 
        category: "Acoustic", 
        instrument: "FLUTE",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["nature", "wind", "soft"],
        settings: { audioReverbLevel: 0.2, melodyInstrument: 'FLUTE', audioEcho: true, audioDelayTime: 0.5, audioDelayFeedback: 0.4 } 
    },
    { 
        name: "Clarinet Solo", 
        category: "Acoustic", 
        instrument: "CLARINET",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["jazz", "wind", "mellow"],
        settings: { audioReverbLevel: 0.2, melodyInstrument: 'CLARINET' } 
    },
    { 
        name: "Trumpet Recital", 
        category: "Acoustic", 
        instrument: "TRUMPET",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["bright", "brass", "classic"],
        settings: { audioReverbLevel: 0.3, melodyInstrument: 'TRUMPET', audioEcho: true, audioDelayTime: 0.2, audioDelayFeedback: 0.3 } 
    },

    // ADDITIONAL VARIATIONS
    { 
        name: "Lo-Fi Beats", 
        category: "Retro", 
        instrument: "ELECTRIC_PIANO",
        echoType: "NONE",
        clarity: "MUFFLED",
        tags: ["chill", "lo-fi", "study"],
        settings: { audioLowPassFreq: 2000, audioDistortionLevel: 5, melodyInstrument: 'ELECTRIC_PIANO' } 
    },
    { 
        name: "Synthwave Lead", 
        category: "Electronic", 
        instrument: "SAWTOOTH_LEAD",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["80s", "retro", "synth"],
        settings: { audioReverbLevel: 0.4, melodyInstrument: 'SAWTOOTH_LEAD', audioEcho: true, audioDelayTime: 0.3, audioDelayFeedback: 0.4 } 
    },
    { 
        name: "Deep House Bass", 
        category: "Electronic", 
        instrument: "SYNTH_BASS_1",
        echoType: "NONE",
        clarity: "MUFFLED",
        tags: ["house", "low", "club"],
        settings: { audioLowPassFreq: 400, melodyInstrument: 'SYNTH_BASS_1' } 
    },
    { 
        name: "Chillwave Pad", 
        category: "Atmospheric", 
        instrument: "WARM_PAD",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["soft", "chill", "vast"],
        settings: { audioReverbLevel: 0.7, melodyInstrument: 'WARM_PAD' } 
    },
    { 
        name: "Hardstyle Lead", 
        category: "Electronic", 
        instrument: "SYNTH_BRASS_2",
        echoType: "NONE",
        clarity: "DISTORTED",
        tags: ["hard", "edm", "lead"],
        settings: { audioDistortionLevel: 30, melodyInstrument: 'SYNTH_BRASS_2' } 
    },
    { 
        name: "Future Garage", 
        category: "Electronic", 
        instrument: "SYNTH_PLUCK",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["uk", "garage", "pluck"],
        settings: { audioEcho: true, audioDelayTime: 0.25, melodyInstrument: 'SYNTH_PLUCK', audioDelayFeedback: 0.5 } 
    },
    { 
        name: "Neuro Bass", 
        category: "Electronic", 
        instrument: "SYNTH_BASS_2",
        echoType: "NONE",
        clarity: "DISTORTED",
        tags: ["dnb", "heavy", "bass"],
        settings: { audioDistortionLevel: 60, audioLowPassFreq: 1200, melodyInstrument: 'SYNTH_BASS_2' } 
    },
    { 
        name: "Liquid DnB", 
        category: "Electronic", 
        instrument: "WARM_PAD",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["dnb", "smooth", "pad"],
        settings: { audioReverbLevel: 0.5, melodyInstrument: 'WARM_PAD', audioEcho: true, audioDelayTime: 0.4, audioDelayFeedback: 0.3 } 
    },
    { 
        name: "Psytrance Lead", 
        category: "Electronic", 
        instrument: "SAWTOOTH_LEAD",
        echoType: "SHORT",
        clarity: "CLEAR",
        tags: ["psy", "fast", "lead"],
        settings: { audioDelayTime: 0.125, melodyInstrument: 'SAWTOOTH_LEAD', audioEcho: true, audioDelayFeedback: 0.6 } 
    },
    { 
        name: "Ambient Piano", 
        category: "Atmospheric", 
        instrument: "GRAND_PIANO",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["soft", "piano", "vast"],
        settings: { audioReverbLevel: 0.9, melodyInstrument: 'GRAND_PIANO', audioEcho: true, audioDelayTime: 1.0, audioDelayFeedback: 0.5 } 
    },

    // LO-FI & CHILL
    { 
        name: "Lo-Fi Morning", 
        category: "Lo-Fi", 
        instrument: "ELECTRIC_PIANO",
        echoType: "NONE",
        clarity: "MUFFLED",
        tags: ["chill", "lo-fi", "morning"],
        settings: { audioLowPassFreq: 1500, audioDistortionLevel: 5, melodyInstrument: 'ELECTRIC_PIANO' } 
    },
    { 
        name: "Vinyl Crackle", 
        category: "Lo-Fi", 
        instrument: "RAIN_FX",
        echoType: "NONE",
        clarity: "DISTORTED",
        tags: ["retro", "noise", "lo-fi"],
        settings: { audioDistortionLevel: 10, audioHighPassFreq: 1000, melodyInstrument: 'RAIN_FX' } 
    },
    { 
        name: "Study Beats", 
        category: "Lo-Fi", 
        instrument: "SYNTH_PLUCK",
        echoType: "STEREO",
        clarity: "MUFFLED",
        tags: ["focus", "lo-fi", "study"],
        settings: { audioLowPassFreq: 2000, melodyInstrument: 'SYNTH_PLUCK', audioEcho: true, audioDelayTime: 0.3, audioDelayFeedback: 0.4 } 
    },
    { 
        name: "Rainy Cafe", 
        category: "Lo-Fi", 
        instrument: "RAIN_FX",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["rain", "cafe", "lo-fi"],
        settings: { audioReverbLevel: 0.4, melodyInstrument: 'RAIN_FX', audioLowPassFreq: 3000, audioEcho: true, audioDelayTime: 0.5, audioDelayFeedback: 0.3 } 
    },
    { 
        name: "Nostalgic Tape", 
        category: "Lo-Fi", 
        instrument: "HONKY_TONK",
        echoType: "NONE",
        clarity: "DISTORTED",
        tags: ["retro", "tape", "lo-fi"],
        settings: { audioPitchShift: -1, audioDistortionLevel: 15, melodyInstrument: 'HONKY_TONK' } 
    },
    { 
        name: "Chill Hop", 
        category: "Lo-Fi", 
        instrument: "SYNTH_BASS_1",
        echoType: "NONE",
        clarity: "MUFFLED",
        tags: ["chill", "bass", "lo-fi"],
        settings: { audioLowPassFreq: 1200, melodyInstrument: 'SYNTH_BASS_1' } 
    },
    { 
        name: "Dreamy Rhodes", 
        category: "Lo-Fi", 
        instrument: "ELECTRIC_PIANO",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["dream", "soft", "lo-fi"],
        settings: { audioReverbLevel: 0.6, melodyInstrument: 'ELECTRIC_PIANO', audioEcho: true, audioDelayTime: 0.4, audioDelayFeedback: 0.4 } 
    },
    { 
        name: "Sunset Drive", 
        category: "Lo-Fi", 
        instrument: "WARM_PAD",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["retro", "drive", "lo-fi"],
        settings: { audioEcho: true, audioDelayTime: 0.5, melodyInstrument: 'WARM_PAD', audioReverbLevel: 0.5, audioDelayFeedback: 0.6 } 
    },
    { 
        name: "Midnight Snack", 
        category: "Lo-Fi", 
        instrument: "PURE_SINE",
        echoType: "NONE",
        clarity: "MUFFLED",
        tags: ["soft", "low", "lo-fi"],
        settings: { audioLowPassFreq: 800, melodyInstrument: 'PURE_SINE' } 
    },
    { 
        name: "Old Radio", 
        category: "Lo-Fi", 
        instrument: "GRAND_PIANO",
        echoType: "NONE",
        clarity: "DISTORTED",
        tags: ["retro", "radio", "lo-fi"],
        settings: { audioDistortionLevel: 40, audioLowPassFreq: 2500, audioHighPassFreq: 500, melodyInstrument: 'GRAND_PIANO' } 
    },

    // SPACE & SCI-FI
    { 
        name: "Black Hole", 
        category: "Space", 
        instrument: "ALIEN_DRONE",
        echoType: "NONE",
        clarity: "AMBIENT",
        tags: ["dark", "vast", "space"],
        settings: { audioReverbLevel: 1.0, audioPitchShift: -24, melodyInstrument: 'ALIEN_DRONE' } 
    },
    { 
        name: "Supernova", 
        category: "Space", 
        instrument: "SAWTOOTH_LEAD",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["bright", "epic", "space"],
        settings: { audioEcho: true, audioDelayTime: 0.1, audioDelayFeedback: 0.9, melodyInstrument: 'SAWTOOTH_LEAD' } 
    },
    { 
        name: "Pulsar", 
        category: "Space", 
        instrument: "SQUARE_LEAD",
        echoType: "SHORT",
        clarity: "CLEAR",
        tags: ["pulse", "digital", "space"],
        settings: { audioEcho: true, audioDelayTime: 0.05, melodyInstrument: 'SQUARE_LEAD', audioDelayFeedback: 0.8 } 
    },
    { 
        name: "Galactic Wind", 
        category: "Space", 
        instrument: "WIND_FX",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["nature", "vast", "space"],
        settings: { audioReverbLevel: 0.8, melodyInstrument: 'WIND_FX' } 
    },
    { 
        name: "Satellite Ping", 
        category: "Space", 
        instrument: "TINKLE_BELL",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["tech", "bells", "space"],
        settings: { audioReverbLevel: 0.3, melodyInstrument: 'TINKLE_BELL', audioEcho: true, audioDelayTime: 0.5, audioDelayFeedback: 0.4 } 
    },
    { 
        name: "Alien Contact", 
        category: "Space", 
        instrument: "SPACE_VOICE",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["vocal", "weird", "space"],
        settings: { audioEcho: true, audioDelayTime: 0.2, melodyInstrument: 'SPACE_VOICE', audioReverbLevel: 0.6, audioDelayFeedback: 0.5 } 
    },
    { 
        name: "Wormhole Jump", 
        category: "Space", 
        instrument: "SWEEP_PAD",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["movement", "vast", "space"],
        settings: { audioPitchShift: 12, melodyInstrument: 'SWEEP_PAD', audioReverbLevel: 0.7 } 
    },
    { 
        name: "Moon Base", 
        category: "Space", 
        instrument: "NEW_AGE_PAD",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["tech", "soft", "space"],
        settings: { audioReverbLevel: 0.5, melodyInstrument: 'NEW_AGE_PAD', audioEcho: true, audioDelayTime: 0.4, audioDelayFeedback: 0.3 } 
    },
    { 
        name: "Asteroid Belt", 
        category: "Space", 
        instrument: "CRYSTAL_FX",
        echoType: "NONE",
        clarity: "DISTORTED",
        tags: ["metal", "harsh", "space"],
        settings: { audioDistortionLevel: 10, melodyInstrument: 'CRYSTAL_FX' } 
    },
    { 
        name: "Cosmic Dust", 
        category: "Space", 
        instrument: "ATMOSPHERE_FX",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["soft", "vast", "space"],
        settings: { audioReverbLevel: 0.9, melodyInstrument: 'ATMOSPHERE_FX' } 
    },

    // DARK & HORROR
    { 
        name: "Abandoned Asylum", 
        category: "Dark", 
        instrument: "ECHOES_FX",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["horror", "ghostly", "dark"],
        settings: { audioReverbLevel: 0.9, audioDistortionLevel: 20, melodyInstrument: 'ECHOES_FX', audioEcho: true, audioDelayTime: 1.0, audioDelayFeedback: 0.7 } 
    },
    { 
        name: "Graveyard Shift", 
        category: "Dark", 
        instrument: "CHURCH_BELL",
        echoType: "NONE",
        clarity: "AMBIENT",
        tags: ["horror", "bells", "dark"],
        settings: { audioPitchShift: -12, melodyInstrument: 'CHURCH_BELL', audioReverbLevel: 0.6 } 
    },
    { 
        name: "Slasher Theme", 
        category: "Dark", 
        instrument: "VIOLIN",
        echoType: "NONE",
        clarity: "DISTORTED",
        tags: ["horror", "strings", "dark"],
        settings: { audioDistortionLevel: 40, melodyInstrument: 'VIOLIN' } 
    },
    { 
        name: "Deep Terror", 
        category: "Dark", 
        instrument: "ALIEN_DRONE",
        echoType: "NONE",
        clarity: "MUFFLED",
        tags: ["horror", "low", "dark"],
        settings: { audioLowPassFreq: 200, melodyInstrument: 'ALIEN_DRONE', audioReverbLevel: 0.8 } 
    },
    { 
        name: "Ghostly Piano", 
        category: "Dark", 
        instrument: "GRAND_PIANO",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["horror", "piano", "dark"],
        settings: { audioReverbLevel: 0.8, audioPitchShift: -5, melodyInstrument: 'GRAND_PIANO', audioEcho: true, audioDelayTime: 0.8, audioDelayFeedback: 0.6 } 
    },
    { 
        name: "Industrial Hell", 
        category: "Dark", 
        instrument: "DISTORTION_GUITAR",
        echoType: "NONE",
        clarity: "DISTORTED",
        tags: ["horror", "heavy", "dark"],
        settings: { audioDistortionLevel: 100, melodyInstrument: 'DISTORTION_GUITAR' } 
    },
    { 
        name: "Shadow Realm", 
        category: "Dark", 
        instrument: "HALO_PAD",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["horror", "vast", "dark"],
        settings: { audioReverbLevel: 0.7, melodyInstrument: 'HALO_PAD', audioPitchShift: -7 } 
    },
    { 
        name: "Cursed Music Box", 
        category: "Dark", 
        instrument: "MUSIC_BOX",
        echoType: "STEREO",
        clarity: "DISTORTED",
        tags: ["horror", "bells", "dark"],
        settings: { audioReverbLevel: 0.5, audioDistortionLevel: 10, melodyInstrument: 'MUSIC_BOX', audioPitchShift: -2, audioEcho: true, audioDelayTime: 0.4, audioDelayFeedback: 0.4 } 
    },
    { 
        name: "Nightmare Fuel", 
        category: "Dark", 
        instrument: "GOBLINS_FX",
        echoType: "SHORT",
        clarity: "DISTORTED",
        tags: ["horror", "weird", "dark"],
        settings: { audioEcho: true, audioDelayTime: 0.01, melodyInstrument: 'GOBLINS_FX', audioDelayFeedback: 0.9 } 
    },
    { 
        name: "The Abyss", 
        category: "Dark", 
        instrument: "PURE_SINE",
        echoType: "NONE",
        clarity: "AMBIENT",
        tags: ["horror", "low", "dark"],
        settings: { audioReverbLevel: 1.0, melodyInstrument: 'PURE_SINE', audioPitchShift: -24 } 
    },

    // MEDITATION & ZEN
    { 
        name: "Zen Meditation", 
        category: "Meditation", 
        instrument: "KOTO",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["zen", "peaceful", "meditation"],
        settings: { audioReverbLevel: 0.6, melodyInstrument: 'KOTO', audioEcho: true, audioDelayTime: 0.5, audioDelayFeedback: 0.4 } 
    },
    { 
        name: "Tibetan Bowl", 
        category: "Meditation", 
        instrument: "STEEL_DRUMS",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["zen", "bells", "meditation"],
        settings: { audioReverbLevel: 0.8, melodyInstrument: 'STEEL_DRUMS', audioPitchShift: -5, audioEcho: true, audioDelayTime: 1.0, audioDelayFeedback: 0.6 } 
    },
    { 
        name: "Morning Mist", 
        category: "Meditation", 
        instrument: "FLUTE",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["zen", "nature", "meditation"],
        settings: { audioReverbLevel: 0.5, melodyInstrument: 'FLUTE', audioEcho: true, audioDelayTime: 0.4, audioDelayFeedback: 0.4 } 
    },
    { 
        name: "Inner Peace", 
        category: "Meditation", 
        instrument: "WARM_PAD",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["zen", "soft", "meditation"],
        settings: { audioReverbLevel: 0.7, melodyInstrument: 'WARM_PAD' } 
    },
    { 
        name: "Sacred Temple", 
        category: "Meditation", 
        instrument: "CHURCH_BELL",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["zen", "bells", "meditation"],
        settings: { audioReverbLevel: 0.9, melodyInstrument: 'CHURCH_BELL', audioPitchShift: -12, audioEcho: true, audioDelayTime: 1.5, audioDelayFeedback: 0.7 } 
    },
    { 
        name: "Floating Spirit", 
        category: "Meditation", 
        instrument: "SPACE_VOICE",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["zen", "vocal", "meditation"],
        settings: { audioReverbLevel: 0.8, melodyInstrument: 'SPACE_VOICE', audioEcho: true, audioDelayTime: 1.0, audioDelayFeedback: 0.6 } 
    },
    { 
        name: "Healing Water", 
        category: "Meditation", 
        instrument: "WATER_FX",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["zen", "nature", "meditation"],
        settings: { audioReverbLevel: 0.4, melodyInstrument: 'WATER_FX', audioEcho: true, audioDelayTime: 0.2, audioDelayFeedback: 0.8 } 
    },
    { 
        name: "Om Chant", 
        category: "Meditation", 
        instrument: "VOICE_OOHS",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["zen", "vocal", "meditation"],
        settings: { audioReverbLevel: 0.6, melodyInstrument: 'VOICE_OOHS', audioEcho: true, audioDelayTime: 0.8, audioDelayFeedback: 0.5 } 
    },
    { 
        name: "Crystal Bowl", 
        category: "Meditation", 
        instrument: "CRYSTAL_FX",
        echoType: "LONG",
        clarity: "CLEAR",
        tags: ["zen", "bells", "meditation"],
        settings: { audioReverbLevel: 0.9, melodyInstrument: 'CRYSTAL_FX', audioEcho: true, audioDelayTime: 1.2, audioDelayFeedback: 0.6 } 
    },
    { 
        name: "Eternal Breath", 
        category: "Meditation", 
        instrument: "WIND_FX",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["zen", "nature", "meditation"],
        settings: { audioReverbLevel: 0.7, melodyInstrument: 'WIND_FX' } 
    },

    // CYBERPUNK & FUTURE
    { 
        name: "Neo Tokyo", 
        category: "Cyberpunk", 
        instrument: "SAWTOOTH_LEAD",
        echoType: "STEREO",
        clarity: "DISTORTED",
        tags: ["cyber", "future", "lead"],
        settings: { audioDistortionLevel: 20, melodyInstrument: 'SAWTOOTH_LEAD', audioDelayTime: 0.25, audioEcho: true, audioDelayFeedback: 0.4 } 
    },
    { 
        name: "Hack the Planet", 
        category: "Cyberpunk", 
        instrument: "8BIT_LEAD",
        echoType: "NONE",
        clarity: "DISTORTED",
        tags: ["cyber", "tech", "lead"],
        settings: { audioDistortionLevel: 50, melodyInstrument: '8BIT_LEAD' } 
    },
    { 
        name: "Neural Link", 
        category: "Cyberpunk", 
        instrument: "SYNTH_PLUCK",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["cyber", "tech", "pluck"],
        settings: { audioEcho: true, audioDelayTime: 0.1, melodyInstrument: 'SYNTH_PLUCK', audioDelayFeedback: 0.8 } 
    },
    { 
        name: "Chrome Streets", 
        category: "Cyberpunk", 
        instrument: "SYNTH_BASS_2",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["cyber", "future", "bass"],
        settings: { audioReverbLevel: 0.4, melodyInstrument: 'SYNTH_BASS_2' } 
    },
    { 
        name: "Data Overload", 
        category: "Cyberpunk", 
        instrument: "SCI_FI_FX",
        echoType: "NONE",
        clarity: "DISTORTED",
        tags: ["cyber", "tech", "noise"],
        settings: { audioDistortionLevel: 80, melodyInstrument: 'SCI_FI_FX' } 
    },
    { 
        name: "Synthetic Soul", 
        category: "Cyberpunk", 
        instrument: "SYNTH_VOICE",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["cyber", "future", "vocal"],
        settings: { audioReverbLevel: 0.6, melodyInstrument: 'SYNTH_VOICE', audioEcho: true, audioDelayTime: 0.4, audioDelayFeedback: 0.5 } 
    },
    { 
        name: "Glitch in Matrix", 
        category: "Cyberpunk", 
        instrument: "GOBLINS_FX",
        echoType: "SHORT",
        clarity: "DISTORTED",
        tags: ["cyber", "glitch", "weird"],
        settings: { audioEcho: true, audioDelayTime: 0.05, melodyInstrument: 'GOBLINS_FX', audioDelayFeedback: 0.9 } 
    },
    { 
        name: "Night City", 
        category: "Cyberpunk", 
        instrument: "POLYSYNTH_PAD",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["cyber", "future", "pad"],
        settings: { audioReverbLevel: 0.5, melodyInstrument: 'POLYSYNTH_PAD', audioEcho: true, audioDelayTime: 0.5, audioDelayFeedback: 0.4 } 
    },
    { 
        name: "Cybernetic Arm", 
        category: "Cyberpunk", 
        instrument: "HELICOPTER",
        echoType: "NONE",
        clarity: "DISTORTED",
        tags: ["cyber", "tech", "noise"],
        settings: { audioDistortionLevel: 30, melodyInstrument: 'HELICOPTER', audioPitchShift: 12 } 
    },
    { 
        name: "Virtual Reality", 
        category: "Cyberpunk", 
        instrument: "SPACE_VOICE",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["cyber", "future", "vocal"],
        settings: { audioReverbLevel: 0.8, melodyInstrument: 'SPACE_VOICE', audioEcho: true, audioDelayTime: 1.0, audioDelayFeedback: 0.6 } 
    },

    // CLASSICAL & BAROQUE
    { 
        name: "Bach Cello", 
        category: "Classical", 
        instrument: "CELLO",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["classic", "strings", "mellow"],
        settings: { audioReverbLevel: 0.3, melodyInstrument: 'CELLO' } 
    },
    { 
        name: "Mozart Piano", 
        category: "Classical", 
        instrument: "GRAND_PIANO",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["classic", "piano", "pure"],
        settings: { audioReverbLevel: 0.2, melodyInstrument: 'GRAND_PIANO' } 
    },
    { 
        name: "Vivaldi Violin", 
        category: "Classical", 
        instrument: "VIOLIN",
        echoType: "STEREO",
        clarity: "CLEAR",
        tags: ["classic", "strings", "high"],
        settings: { audioReverbLevel: 0.4, melodyInstrument: 'VIOLIN', audioEcho: true, audioDelayTime: 0.2, audioDelayFeedback: 0.3 } 
    },
    { 
        name: "Handel Organ", 
        category: "Classical", 
        instrument: "CHURCH_ORGAN",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["classic", "organ", "grand"],
        settings: { audioReverbLevel: 0.6, melodyInstrument: 'CHURCH_ORGAN', audioEcho: true, audioDelayTime: 1.0, audioDelayFeedback: 0.5 } 
    },
    { 
        name: "Beethoven Symphony", 
        category: "Classical", 
        instrument: "ORCHESTRA_HIT",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["classic", "orchestra", "impact"],
        settings: { audioReverbLevel: 0.5, melodyInstrument: 'ORCHESTRA_HIT' } 
    },
    { 
        name: "Chopin Nocturne", 
        category: "Classical", 
        instrument: "BRIGHT_PIANO",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["classic", "piano", "mellow"],
        settings: { audioReverbLevel: 0.4, melodyInstrument: 'BRIGHT_PIANO', audioEcho: true, audioDelayTime: 0.4, audioDelayFeedback: 0.4 } 
    },
    { 
        name: "Tchaikovsky Ballet", 
        category: "Classical", 
        instrument: "STRING_ENSEMBLE_1",
        echoType: "STEREO",
        clarity: "AMBIENT",
        tags: ["classic", "strings", "grand"],
        settings: { audioReverbLevel: 0.5, melodyInstrument: 'STRING_ENSEMBLE_1', audioEcho: true, audioDelayTime: 0.3, audioDelayFeedback: 0.3 } 
    },
    { 
        name: "Debussy Clair", 
        category: "Classical", 
        instrument: "GRAND_PIANO",
        echoType: "LONG",
        clarity: "AMBIENT",
        tags: ["classic", "piano", "soft"],
        settings: { audioReverbLevel: 0.7, melodyInstrument: 'GRAND_PIANO', audioEcho: true, audioDelayTime: 0.8, audioDelayFeedback: 0.5 } 
    },
    { 
        name: "Wagner Valkyrie", 
        category: "Classical", 
        instrument: "BRASS_SECTION",
        echoType: "NONE",
        clarity: "CLEAR",
        tags: ["classic", "brass", "grand"],
        settings: { audioReverbLevel: 0.6, melodyInstrument: 'BRASS_SECTION' } 
    },
    { 
        name: "Stravinsky Rite", 
        category: "Classical", 
        instrument: "BASSOON",
        echoType: "NONE",
        clarity: "DISTORTED",
        tags: ["classic", "wind", "raw"],
        settings: { audioDistortionLevel: 10, melodyInstrument: 'BASSOON' } 
    },
];
